export default {
  // Navigation
  nav: {
    trade: 'Trade',
    dashboard: 'Dashboard',
    chart: 'Chart',
    logs: 'Logs',
    settings: 'Settings',
    backtest: 'Backtest',
    replay: 'Replay',
    downloadData: 'Download Data',
    pairlistConfig: 'Pairlist Config',
    lockLayout: 'Lock dynamic Layout',
    resetLayout: 'Reset Layout',
    logout: 'Logout',
    exportPdf: 'Export as PDF',
    strategyDev: 'Strategy Dev',
    journal: 'Journal',
    editPage: 'Edit dashboard',
    editModeHint: 'Edit mode — Move, resize and hide widgets',
    editModeDone: 'Done',
    opacity: 'Opacity',
    bgAnimation: 'Animation',
    bgAnimationDesc:
      'Toggles the animated gradient background on the dashboard. Disabling it reduces GPU usage and improves performance on older devices.',
    exportConfig: 'Export config',
    importConfig: 'Import config',
    pageConfig: 'Page config',
    configDesc: 'Save and restore your dashboard layout preferences and display settings.',
    resetLayout: 'Reset layout',
    resetLayoutConfirm:
      'Are you sure you want to reset the dashboard to its default layout? You will lose all your window adjustments, column settings, placement, size, etc.',
    optimizeLayout: 'Optimize layout',
    optimizeLayoutConfirm:
      'All visible widgets will be moved as far up and to the left as possible, while keeping their current size. This does not affect hidden widgets.',
    newVersionAvailable: 'New version available',
    includeAuth: 'Include authentication tokens',
    authPasswordRequired:
      'Tokens grant full bot control. A password is required to encrypt the file.',
    layoutOnlyDesc: 'Layout, themes and display preferences only — no sensitive data.',
    authIncludedDesc:
      'Includes bot connection tokens. The file will be encrypted with your password.',
    encryptionPassword: 'Encryption password',
    passwordMinChars: 'Minimum 8 characters',
    export: 'Export',
    cancel: 'Cancel',
    importPreview: 'Import preview',
    exportDate: 'Exported on',
    fileAge: 'File age',
    daysUnit: 'days',
    containsAuth: 'Authentication',
    authNotIncluded: 'Layout only',
    authEncrypted: 'Encrypted',
    authUnencrypted: 'Unencrypted (legacy)',
    settingsCount: 'Settings',
    botsCount: 'Bots',
    integrityCheck: 'Integrity',
    integrityValid: 'Valid',
    integrityFailed: 'Failed',
    integrityNA: 'N/A',
    expiredWarning:
      'This file is over 7 days old. Authentication tokens may be compromised or expired.',
    integrityFailedDetail:
      'The file has been modified since export. It may have been tampered with. Import is blocked.',
    enterPassword: 'Enter the encryption password',
    wrongPassword: 'Wrong password — please try again.',
    integrityFailedImport: 'Integrity check failed — the file may have been tampered with.',
    passwordNeeded: 'This file is encrypted — a password is required.',
    invalidFile: 'Invalid or corrupted config file.',
    importSuccess: 'Configuration restored',
    reloading: 'Reloading page...',
    applyConfig: 'Apply configuration',
    encryptionUnavailable:
      'Encryption requires HTTPS. Use a secure connection or export without tokens.',
  },

  // Dashboard
  dashboard: {
    profitOverTime: 'Profit over time (combined)',
    botComparison: 'Global · Bot comparison',
    openTrades: 'Bot · Open trades',
    openTradesDesc:
      'Open trades of all selected bots. Click on a trade to go to the trade page for that trade/bot.',
    closedTrades: 'Bot · Closed trades',
    closedTradesDesc:
      'Closed trades for all selected bots. Click on a trade to go to the trade page for that trade/bot.',
    profitBenchmark: 'Bot · Profit & benchmarks',
    cumulativeProfit: 'Cumulative Profit',
    profitDistribution: 'Bot · Profit distribution',
    tradesLog: 'Trades Log',
    activityTimeline: 'Global · Activity timeline',
    marketOverview: 'Global · Market pulse',
    performanceHeatmap: 'Performance Heatmap',
    riskOverview: 'Global · Risk overview',
    stressTest: 'Global · Stress test',
    logConsole: 'System · Log console',
    rateBudget: 'Rate Budget',
    ratePulse: 'Rate Pulse',

    cacheHealth: 'Cache Health',
    rateMonitor: 'System · API budget',
    requestTimeline: 'System · API requests',
    infraHealth: 'System · Infrastructure',
    volumeComparator: 'Global · Volume comparator',
    periodBreakdown: 'Global · Period breakdown',
    botProfitComparison: 'Bot · Profit per bot',
    botComparisonDesc:
      'Health and performance of every connected bot. The checkboxes select which bots feed the "Selection" widgets.',
    profitBenchmarkDesc: 'Combined profit of the selected bots versus benchmarks.',
    profitDistributionDesc: 'Distribution of closed-trade profits for the selected bots.',
    activityTimelineDesc: 'Chronological feed of events (trades, DCA, alerts) across all bots.',
    marketOverviewDesc:
      'Market snapshot for the pairs traded by the bots. Refreshes every 30s.',
    riskOverviewDesc: 'Aggregated exposure and risk indicators across all bots.',
    stressTestDesc:
      'Simulates a market move (-50% to +50%) against all open positions, including liquidations.',
    logConsoleDesc: 'Aggregated bot logs (warnings and errors). Refreshes every 10s.',
    rateMonitorDesc: 'Exchange API budget: request rate, cache hit ratio, 429 errors.',
    requestTimelineDesc: 'Timeline of API requests per bot: direct, cached, errors, latency.',
    infraHealthDesc: 'Bot process health: state, uptime, heartbeats, pairlist size.',
    volumeComparatorDesc: 'Bot traded volume versus exchange volume per period.',
    periodBreakdownDesc: 'Profit broken down by day, week or month across all bots.',
    botProfitComparisonDesc:
      'Profit contribution per bot over the chosen period, for the selected bots.',
    opened: 'opened',
    closed: 'closed',
  },
  widgetScope: {
    selection: 'Selection',
    selectionTitle: 'Data from the bots currently selected in the bot comparison widget',
    all: 'All bots',
    allTitle: 'Data from all connected bots, regardless of selection',
    fleet: 'Fleet',
    fleetTitle:
      'Server-side aggregate over the entire fleet, including bots not connected in this browser',
    system: 'System',
    systemTitle: 'Infrastructure and API monitoring, not trading data',
  },
  widgetState: {
    retry: 'Retry',
    fetchError: 'Failed to load data',
  },
  botProfitComparison: {
    fleetTotal: 'Fleet total',
    bots: 'Bots',
    trades: 'Trades',
    tradeCount: '{n} trades in period',
    sortBy: 'Sort by',
    sortProfit: 'Profit',
    sortMagnitude: 'Magnitude',
    sortName: 'Name',
    exportPNG: 'Export as image',
    noData: 'No closed trades for the selected bots and period',
  },
  volumeComparator: {
    exchangeVolume: 'Exchange Volume',
    botVolume: 'Bot Volume',
    tradeCount: 'Trades',
    profit: 'Profit',
    anomalies: 'Anomalies',
    volumeRatio: 'Vol Ratio',
    coverage: 'pair coverage',
    correlation: 'Correlation',
    noData: 'No OHLCV data available. Run freqtrade download-data for whitelist pairs.',
    loading: 'Loading volume data...',
    profitPerVol: 'Profit/Vol',
  },

  // Cumulative Profit Enhanced
  cumProfit: {
    title: 'Cumulative Profit',
    tabProfit: 'Profit',
    tabProfitBalance: 'Profit + Balance',
    tabPerBot: 'Per Bot',
    tabProportion: 'Proportion',
    profit: 'Profit',
    balance: 'Balance',
    loadingBenchmarks: 'Loading benchmark data...',
    noData: 'No trade data available',
    statTotalProfit: 'Total Profit',
    statPeak: 'Peak Profit',
    statDrawdown: 'Max Drawdown',
    statRecovery: 'Recovery %',
    statBestBot: 'Best Bot',
    highWaterMark: 'High Water Mark',
  },

  // Profit Distribution Enhanced
  profitDist: {
    tabHistogram: 'Histogram',
    tabPerBot: 'Per Bot',
    tabPerPair: 'Per Pair',
    tabByDuration: 'By Duration',
    tradeCount: 'Trade count',
    profitPct: 'Profit %',
    profitAbs: 'Profit ({currency})',
    avgProfit: 'Avg profit',
    avgProfitPct: 'Avg profit %',
    duration: 'Duration',
    trades: 'Trades',
    mean: 'Mean',
    loadingBenchmarks: 'Loading benchmark data...',
    noData: 'No trade data available',
    statMean: 'Mean',
    statMedian: 'Median',
    statStdDev: 'Std Dev',
    statSkewness: 'Skewness',
    statBest: 'Best',
    statWorst: 'Worst',
    statWinRate: 'Win Rate',
    statTrades: 'Trades',
    skewnessPositive: 'Positive skew: more large wins',
    skewnessNegative: 'Negative skew: more large losses',
    tabByLeverage: 'By Leverage',
    leverage: 'Leverage',
    filterAll: 'All',
    filterSpot: 'Spot only',
    filterFutures: 'Futures only',
    filterLong: 'Long only',
    filterShort: 'Short only',
    profitMin: 'Min Profit %',
    profitMax: 'Max Profit %',
    binCount: 'Number of bins',
    filterRange: 'Filter range',
    clearFilter: 'Clear filter',
  },

  // Profit Over Time Enhanced
  profitEnhanced: {
    combined: 'Combined',
    projected: 'Projected (incl. open)',
    combinedMode: 'Combined (all bots summed)',
    perBotMode: 'Per bot (separate lines)',
    stackedMode: 'Stacked area (contribution)',
    absLabel: 'USDC',
    profitAbs: 'Profit (USDC)',
    profitPct: 'Profit (%)',
    periodReturn: 'Period Return',
    bestDay: 'Best Day',
    worstDay: 'Worst Day',
    avgDaily: 'Avg Daily',
    trades: 'Trades',
    sharpe: 'Sharpe',
    maxDD: 'Max DD',
    winRate: 'Win Rate',
    profitFactor: 'Profit Factor',
    exportCSV: 'Export chart data as CSV',
    loadingBenchmarks: 'Loading benchmark data...',
    noData: 'No trade data available for this period',
  },

  // Profit Benchmark Chart (merged profit + cumulative + benchmarks)
  profitBenchmark: {
    tabCombined: 'Combined',
    tabPerBot: 'Per Bot',
    tabCumulative: 'Cumulative',
    combined: 'Combined',
    projected: 'Projected (incl. open)',
    highWaterMark: 'High Water Mark',
    normAbsolute: 'Absolute',
    normPctFromStart: '% from start',
    normPctFromCapital: '% from capital',
    profitAbs: 'Profit',
    profitPct: 'Profit (%)',
    benchmarkPct: 'Benchmark (%)',
    periodReturn: 'Period Return',
    vsBTC: 'vs BTC',
    sharpe: 'Sharpe',
    maxDD: 'Max DD',
    winRate: 'Win Rate',
    benchmarks: 'Benchmarks',
    normalization: 'Normalization',
    normExplain: 'How it works',
    normExplainDetail:
      'In "% from start" mode, your profit and benchmarks both start at 0% and show percentage change. This lets you directly compare: did your bots outperform BTC?',
    altProxy: 'alt market proxy',
    solLabel: 'Solana',
    bnbLabel: 'BNB Chain',
    traditionalNote: 'Traditional market benchmarks require API key',
    settings: 'Chart settings',
    exportCSV: 'Export chart data as CSV',
    exportPNG: 'Export chart as PNG image',
    loadingBenchmarks: 'Loading benchmark data...',
    noData: 'No trade data available for this period',
    currencySelector: 'Display currency',
    currencyAuto: 'Auto',
    addBenchmark: 'Add benchmark',
    removeBenchmark: 'Remove {coin} benchmark',
    customCoinGecko: 'Custom (CoinGecko ID)',
    customPlaceholder: 'e.g. cardano',
    customNotFound: 'ID not found on CoinGecko',
    add: 'Add',
    outperforming: 'Outperforming',
    underperforming: 'Underperforming',
    by: 'by',
    descCombined:
      'This chart shows the combined profit of all your selected bots (sum of closed trade profits across all exchanges and stake currencies, converted if needed)',
    descPerBot: "This chart shows each bot's individual profit",
    descCumulative:
      'This chart shows the cumulative running total of all closed trade profits (each trade profit is added chronologically to form the equity curve)',
    descOverPeriod: 'over the last {period}',
    descNormPctStart: 'expressed as percentage change from the start of the period',
    descNormAbsolute: 'in {currency}',
    descNormPctCapital: 'as percentage of starting capital',
    descBenchmarks: 'Benchmark comparison: {list}',
    descBenchmarkHint: 'If your profit line is ABOVE a benchmark, you are outperforming it.',
  },

  // Bot comparison table
  botComparison: {
    botName: 'Bot Name',
    all: 'All',
    showInDashboard: 'Show this bot in Dashboard',
    toggleAll: 'Toggle all bots',
    selectAllBots: 'Click to select all bots',
    selectDryBots: 'Click to select all dry run bots',
    selectLiveBots: 'Click to select all live bots',
    trades: 'Trades',
    openProfit: 'Open Profit',
    totalProfit: 'Total Profit (Open and realized)',
    closedProfit: 'Closed Profit',
    currentProfit: 'Current Profit',
    maxDrawdown: 'Max Drawdown',
    withdrawnLabel: 'of which {amount} withdrawn',
    netAfterWithdrawals: '{amount} net after withdrawals',
    balance: 'Balance',
    winLoss: 'W/L',
    lastTrade: 'Last trade',
    lastTradeOthersToday: 'others today',
    lastTradeOthersTodayTooltip:
      '{n} other trade closed today | {n} other trades closed today',
    offline: 'Offline',
    offlineSince: 'since {duration}',
    dry: 'Dry',
    live: 'Live',
    exchange: 'Exchange',
    selectByExchange: 'Click to select all {exchange} bots',
    stakeAmount: 'Stake Amount',
    port: 'Port',
    strategy: 'Strategy',
    pairCount: 'Pairs',
    stakeCurrencyLabel: 'Currency',
    selectByCurrency: 'Click to select all {currency} bots',
    weeklyProfit: 'Weekly Profit',
    yearlyProfit: 'Yearly Profit',
    monthlyProfit: 'Monthly Profit',
    availableCapital: 'Available Capital (config)',
    tradableBalanceRatio: 'Tradable Ratio (config)',
    availableFunds: 'Available Funds',
    fundsGain: 'Realized gains',
    fundsWithdraw: 'Withdrawals',
    fundsTotal: 'Available funds',
    hostBotBadge: 'host',
    hostBotTooltip: 'This bot serves FreqUI',
    addColumn: 'Add column',
    hideColumn: 'Click to hide this column',
    botOfflineDesc: 'This bot is currently offline. No live data available.',
    lastSeenOnline: 'Last seen online {duration} ago',
    botLoading: 'Bot is starting up...',
    botLoadingDesc: 'Please wait for additional information to load.',
    resetColumns: 'Restore FreqUI columns to their default state',
    columnSettings: 'Visible columns',
    correlation: 'Correlation detected',
    correlationDesc: 'Multiple bots trading the same pair simultaneously',
    renameBot: 'Rename bot',
    dragToReorder: 'Drag to reorder',
    statusLabel: 'Status',
    onlineSince: 'Online since {duration}',
    // Sort & Filter
    sort: 'Sort',
    sortBy: 'Sort by',
    ascending: 'Ascending',
    descending: 'Descending',
    filters: 'Filters',
    visibility: 'Visibility',
    showOnlineSince: 'Show online since date',
    botTags: 'Bot tags',
    byStatus: 'By status',
    byExchange: 'By exchange',
    byCurrency: 'By currency',
    botsHidden: '{count} bot hidden | {count} bots hidden',
    allBotsVisible: 'All bots are visible',
    botsHiddenByFilters: '{count} bot hidden by filters | {count} bots hidden by filters',
    showAllBots: 'Click to show all bots',
    sortCustom: 'Custom order',
    sortByName: 'Bot name',
    sortByStartDate: 'Start date',
    sortByProfit: 'Closed Profit',
    sortByCurrentProfit: 'Current Profit',
    sortByBalance: 'Balance',
    sortByCurrency: 'Currency',
    sortByExchange: 'Exchange',
    sortByStatus: 'Status',
    sortByStrategy: 'Strategy',
    sortByWeekly: 'Weekly Profit',
    sortByMonthly: 'Monthly Profit',
    sortByDrawdown: 'Drawdown',
    sortByWinrate: 'Winrate',
    sortByTradeCount: 'Trade count',
    sortByOpenPositions: 'Open positions',
    tagStatus: 'Status (Dry/Live/Offline)',
    tagExchange: 'Exchange',
    tagCurrency: 'Stake Currency',
    tagPort: 'Port',
    tagTradingMode: 'Trading mode (Futures/Spot)',
    byTradingMode: 'By trading mode',
    filtersTitle: 'Filters',
    resetSort: 'Reset sort',
    resetFilters: 'Reset filters',
    // Alerts
    alerts: 'Alerts',
    alertEnabled: 'Alert enabled',
    lossThreshold: 'Loss threshold',
    positionAtRisk: 'Position at risk: unrealized loss exceeds threshold',
    // Alert system v2
    alertsReset: 'Reset',
    alertCategoryPosition: 'Position',
    alertCategoryLog: 'Logs',
    alertCategoryActivity: 'Activity',
    alertCategorySystem: 'System',
    alertPositionLoss: 'Unrealized loss',
    alertPositionLossDesc: 'Position loss exceeds threshold',
    alertPositionStuck: 'Stuck position',
    alertPositionStuckDesc: 'Held longer than X times average duration',
    alertNearLiquidation: 'Near liquidation',
    alertNearLiquidationDesc: 'Within X% of liquidation price (futures)',
    alertLogErrors: 'Log errors',
    alertLogErrorsDesc: 'Errors detected in recent logs',
    alertOrderFailed: 'Order failed',
    alertOrderFailedDesc: 'Failed to open or close a position',
    alertInsufficientFunds: 'Insufficient funds',
    alertInsufficientFundsDesc: 'Not enough funds to open position',
    alertExchangeError: 'Exchange error',
    alertExchangeErrorDesc: 'Exchange connectivity issues',
    alertWalletMismatch: 'Wallet desync',
    alertWalletMismatchDesc: 'Wallet balance mismatch detected',
    alertNoTradeActivity: 'No trade activity',
    alertNoTradeActivityDesc: 'No trade opened in X hours',
    alertBotOffline: 'Bot offline',
    alertBotOfflineDesc: 'Bot went offline',
    alertHighDrawdown: 'High drawdown',
    alertHighDrawdownDesc: 'Current drawdown exceeds threshold',
    alertCapacityFull: 'Capacity full',
    alertCapacityFullDesc: 'All trade slots are occupied',
    alertAllFundsExposed: 'All funds exposed',
    alertAllFundsExposedDesc: 'Nearly all capital is locked in open positions',
    alertLiquidationBeforeStoploss: 'Liquidation before stoploss',
    alertLiquidationBeforeStoplossDesc: 'Liquidation price is closer than stoploss (futures)',
    alertIncludeLeverage: 'Include leverage',
    alertPerBot: 'Per bot',
    alertAllConfigured: '{count} alert configured | {count} alerts configured',
    alertToggleAllOn: 'All ON',
    alertToggleAllOff: 'All OFF',
    alertGlobalApply: 'Settings apply to all bots. Toggle per bot below.',
    alertActiveCount: '{count} active alert | {count} active alerts',
    alertViewLogs: 'View logs',
    // Bot Groups
    botGroups: 'Bot groups',
    createGroup: 'Create group',
    deleteGroup: 'Delete group',
    ungrouped: 'Ungrouped',
    groupName: 'Group name',
    groupIcon: 'Icon',
    addToGroup: 'Add to group',
    removeFromGroup: 'Remove from group',
    createGroupInline: 'Create a group',
    changeIcon: 'Change icon',
    clearIcon: 'Remove icon',
    resetIcon: 'Reset icon',
    searchIcon: 'Search emoji…',
    recentIcons: 'Recently used',
    noIconResults: 'No emoji matches your search',
    editGroup: 'Edit group',
    moveToFolder: 'Move to folder',
    currentFolder: 'current',
    noGroupsAvailable: 'No folders available. Create one first.',
    alertsTitle: 'Alert Settings',
    groupsTitle: 'Bot Groups',
    noAlerts: 'No alert',
    positionsAtRisk: '{count} position at risk | {count} positions at risk',
    ungroupedBots: 'Ungrouped bots',
    // Custom Tags
    customTags: 'Custom tags',
    addTag: 'Add tag',
    createTag: 'Create tag',
    tagName: 'Tag name',
    tagColor: 'Color',
    deleteTag: 'Delete tag',
    editTag: 'Edit tag',
    filterByTag: 'Click to select bots with this tag',
    byCustomTag: 'By custom tag',
    keyboardShortcuts:
      'Keyboard shortcuts: Esc=close popovers, 1-9=toggle bot, F=filter, S=sort, Ctrl+A=select all',
    botActions: 'Bot actions',
    actionStart: 'Start',
    actionPause: 'Pause (stop buying)',
    actionStop: 'Stop',
    actionReload: 'Reload config',
    actionForceExitAll: 'Force exit all positions',
    viewLogs: 'View logs',
    viewTrades: 'View trades',
    viewJournal: 'View trade journal',
    analyzeStrategy: 'Analyze strategy',
    dryRunReplay: 'Simulate dry-run (replay)',
    dryRunReplayView: 'View running dry-run replay',
    dryRunReplayDone: 'A dry-run replay was already simulated. Reset the dry-run DB to re-run.',
    editConfig: 'Edit configuration',
    confirmAction: 'Confirm action',
    confirmActionMsg: 'Are you sure you want to {action} on {bot}?',
    replay: {
      title: 'Dry-run replay — {bot}',
      intro:
        'Replays the bot’s real live loop over historical data, then seeds the simulated trades into this bot’s dry-run database — as if it had been running since the chosen date.',
      strategy: 'Strategy',
      wallet: 'Simulated wallet',
      pairs: 'Pairs (current filter)',
      loading: 'Loading current pairs…',
      pairsWarning:
        'The replay uses the {n} pairs currently selected by the filter. Dynamic pairlists are not replayed historically → selection bias on these specific pairs.',
      noPairs:
        'Could not determine the bot’s pairs (empty whitelist, no trades, no logged whitelist). Is the bot initialized? Try again once its pairlist is ready.',
      pairsSource_trades:
        'Live whitelist unavailable — using the pairs this bot has actually traded.',
      pairsSource_logs:
        'Live whitelist unavailable — using the bot’s last logged whitelist.',
      startDate: 'Start date',
      endDate: 'End date',
      fundingHint: 'Funding fees are only accurate if you have funding data for the period.',
      preventDry: 'Dry-run only — never places real orders.',
      preventIsolated: 'Runs in an isolated background process — the bot keeps trading.',
      preventOnce: 'One-shot: to re-run, reset the dry-run database.',
      alreadyTitle: 'Already simulated',
      alreadyMsg:
        'A dry-run replay was already seeded on this bot ({timerange}). To run a new one, start from a fresh dry-run database.',
      resultTitle: 'Result (simulated)',
      closed: 'Closed trades',
      winRate: 'Win rate',
      pnl: 'Total P&L',
      doneReload: 'Done — bot reloaded with the simulated history.',
      run: 'Run replay',
      close: 'Close',
      resolution: 'Resolution (sub-step)',
      resolutionHint:
        'Smaller sub-step = slower but more faithful (finer intra-candle order fills). 1m needs 1m data downloaded.',
      today: 'Today',
      stop: 'Stop',
      elapsed: 'Elapsed',
      eta: 'ETA',
      runningTitle: 'Dry-run replay in progress',
      seededTitle: 'Seeded by a dry-run replay ({timerange}) — click to view / re-seed',
      seededTitleShort: 'Seeded by a dry-run replay — click to view / re-seed',
      badge: 'Dry-run replay',
      pausedBadge: 'Replay paused',
      coverageLoading: 'Checking local data…',
      coverageNone:
        'No {tf} data found locally for these pairs — fills at this resolution won’t be available.',
      coverageEarliest:
        'Earliest {tf} data: {date} ({n}/{total} pairs). A replay before this date won’t be faithful at this resolution.',
      startBeforeData: 'No history before {date}; the replay will only be faithful from that date.',
      endFuture:
        'End date is in the future — the replay stops at the latest available data (downloadable up to recent on Hyperliquid).',
      closeContinues:
        'You can close this window — the replay keeps running in the background. A spinner on the bot in “Bot comparison” shows its progress.',
      restore: 'Restore DB',
      restoreHint:
        'Restore the database snapshot taken just before this replay (undo a crashed or unwanted seed). The bot reloads.',
      restoreConfirm:
        'Restore this bot’s database from the pre-replay backup? The current (seeded) database will be overwritten and the bot will reload.',
      tradeBadge: 'replay',
      resetDb: 'Reset the database first',
      resetDbHint:
        'Wipe existing dry-run trades before seeding. Unchecked: existing trades are kept and the replay stops at the first real trade.',
      detailPeriod: 'Period',
      detailDuration: 'Took',
      detailPairs: 'Pairs',
      detailReplayResult: 'Replay result',
      detailCurrent: 'Current (replay + live-dry since)',
      detailOutside: 'Trades since the replay',
      queueTitle: 'Coordinator: {cap} free slots ({cores} cores, {hopt} used by hyperopt)',
      prioritize: 'Prioritize',
      stateQueued: 'Queued — waiting for a free core',
      statePaused: 'Paused — cores busy (hyperopt or higher-priority replays)',
      tradeBadgeHint: 'Simulated trade seeded by a dry-run replay (not live activity).',
    },
  },

  maxDrawdownCard: {
    title: 'Max Drawdown',
    none: 'No drawdown yet',
    noneDesc: 'No peak-to-trough decline recorded.',
    realized: 'Realized (closed)',
    inclOpen: 'Incl. open positions',
    realizedShort: 'Real.',
    openShort: 'Open',
    realizedCurve: 'Realized — closed trades',
    openCurve: 'Including open positions at their lowest',
    openCurveHint: 'The tail projects the open book down to the lowest it reached.',
    notEnoughData: 'Not enough closed trades to draw the curve.',
    peak: 'Peak',
    trough: 'Trough',
    openPositions: 'Open positions (now → lowest)',
    low: 'low',
    responsibleTrades: 'Responsible trades',
    tradesInWindow: 'Trades in the drawdown window',
    group: 'Group',
    summary: 'Summary',
  },

  configEditor: {
    title: 'Edit configuration',
    loading: 'Loading configuration…',
    unsupportedTitle: 'Backend not supported',
    unsupportedMsg:
      "This bot does not expose the config-editor endpoints. Update the bot's freqtrade backend to enable this feature.",
    readOnlyFile: "This bot's config file is not in a writable directory — editing disabled.",
    loadIncomplete:
      "Could not read this bot's config file — editing disabled to avoid overwriting it. Close and reopen the editor.",
    help: 'View freqtrade documentation',
    lockedHint: 'Locked: edit manually in the file (unsafe to change live).',
    restartHint: 'Requires a full bot restart, not just a reload.',
    restart: 'restart',
    revert: 'Revert to inherited value',
    overrideFromConfig: 'Override in config',
    unlimited: 'unlimited',
    none: '(none)',
    choose: 'Choose…',
    source: {
      own: 'set here',
      inherited: 'inherited',
      strategy: 'strategy',
      default: 'default',
    },
    sections: {
      capital: 'Capital & Sizing',
      trading: 'Trading',
      risk: 'Risk & Exits',
      orders: 'Orders & Timeouts',
      pricing: 'Pricing',
      pairlists: 'Pairlists',
      notifications: 'Notifications',
      system: 'System (locked)',
      add: 'Add a parameter',
      raw: 'Raw JSON',
    },
    fields: {
      max_open_trades: 'Max open trades',
      stake_amount: 'Stake per trade',
      tradable_balance_ratio: 'Tradable balance ratio',
      capital_withdrawal: 'Capital withdrawal',
      available_capital: 'Initial reference capital',
      last_stake_amount_min_ratio: 'Last stake min ratio',
      amount_reserve_percent: 'Amount reserve (%)',
      amend_last_stake_amount: 'Amend last stake amount',
      position_adjustment_enable: 'Enable position adjustment (DCA)',
      max_entry_position_adjustment: 'Max entry adjustments',
      bot_name: 'Bot name',
      strategy: 'Strategy',
      process_throttle_secs: 'Loop throttle (s)',
      process_only_new_candles: 'Process only new candles',
      force_entry_enable: 'Allow force entry',
      cancel_open_orders_on_exit: 'Cancel open orders on exit',
      initial_state: 'Initial state',
      fiat_display_currency: 'Fiat display currency',
      stoploss: 'Stop-loss',
      minimal_roi: 'Minimal ROI',
      trailing_stop: 'Trailing stop',
      trailing_stop_positive: 'Trailing stop positive',
      trailing_stop_positive_offset: 'Trailing stop positive offset',
      trailing_only_offset_is_reached: 'Trailing only after offset',
      use_exit_signal: 'Use exit signal',
      exit_profit_only: 'Exit on profit only',
      ignore_roi_if_entry_signal: 'Ignore ROI if entry signal',
      order_types_entry: 'Order type — entry',
      order_types_exit: 'Order type — exit',
      order_types_stoploss: 'Order type — stop-loss',
      stoploss_on_exchange: 'Stop-loss on exchange',
      stoploss_price_type: 'Stop-loss price type',
      tif_entry: 'Time-in-force — entry',
      tif_exit: 'Time-in-force — exit',
      unfilledtimeout_entry: 'Unfilled timeout — entry',
      unfilledtimeout_exit: 'Unfilled timeout — exit',
      unfilledtimeout_unit: 'Timeout unit',
      entry_price_side: 'Price side — entry',
      entry_price_last_balance: 'Last price balance — entry',
      entry_use_order_book: 'Use order book — entry',
      entry_order_book_top: 'Order book depth — entry',
      exit_price_side: 'Price side — exit',
      exit_price_last_balance: 'Last price balance — exit',
      exit_use_order_book: 'Use order book — exit',
      exit_order_book_top: 'Order book depth — exit',
      pairlists: 'Pairlist handlers',
      pair_blacklist: 'Pair blacklist',
      pair_whitelist: 'Pair whitelist',
      telegram_enabled: 'Telegram enabled',
      notify_status: 'Notify status',
      notify_entry: 'Notify entry',
      notify_exit: 'Notify exit',
      notify_protection: 'Notify protection',
      db_url: 'Database URL',
      trading_mode: 'Trading mode',
      margin_mode: 'Margin mode',
      stake_currency: 'Stake currency',
      dry_run: 'Dry-run',
      dry_run_wallet: 'Dry-run wallet',
      exchange_name: 'Exchange',
      api_listen_port: 'API port',
    },
    tagPlaceholder: 'One pair per line, e.g. BTC/USDC:USDC',
    addRoi: 'Add ROI step',
    addIntro: 'Add a freqtrade parameter that is not present in your current config.',
    addedFields: 'Added parameters',
    searchParam: 'Search a parameter…',
    removeParam: 'Remove',
    rawIntro: 'Direct edit of the JSON written to {file}. Validated in real time.',
    schemaWarnings: '{n} schema warning(s)',
    nChanges: '{n} change(s)',
    noChanges: 'No changes',
    restartNeeded: 'restart required',
    cancel: 'Cancel',
    save: 'Save',
    savedTitle: 'Configuration saved',
    savedMsg: "Changes were written to the bot's config file (a .bak backup was created).",
    savedRestartMsg: 'One of the changes requires a full restart: a hot reload will not be enough.',
    savedChoose: 'What would you like to do now?',
    reloadNow: 'Reload config',
    stopNow: 'Stop bot',
    later: 'Later',
    savedTo: 'Configuration saved to {file}',
    saveFailed: 'Save failed: {detail}',
    reloadTriggered: 'Config reload requested',
    stopTriggered: 'Bot stop requested',
    errRequired: 'Required field',
    errNumber: 'Must be a number',
    errInteger: 'Must be an integer',
    errMin: 'Minimum {min}',
    errMax: 'Maximum {max}',
    errPattern: 'Invalid format',
    errBothUnlimited: 'max_open_trades and stake_amount cannot both be unlimited',
    moveUp: 'Move up',
    moveDown: 'Move down',
    removeHandler: 'Remove handler',
    addParam: 'Add parameter',
    addHandler: 'Add handler',
    noPairlist: 'No pairlist handler defined.',
  },

  // Alert Detail Card
  alertDetail: {
    stakeAtRisk: 'Stake at risk',
    ifClosedNow: 'If closed now',
    heldFor: 'Held for {duration} (avg: {avg})',
    lastError: 'Last error',
    viewLogs: 'View logs',
    viewTrades: 'View trades',
    away: 'away',
    currentPrice: 'Current price',
    liqPrice: 'Liq. price',
    locked: 'Locked',
    free: 'Free',
    lastSeen: 'Last seen',
    offlineFor: 'Offline for',
    peakValue: 'Peak value',
    currentValue: 'Current value',
  },

  // Open Profit Card
  openProfitCard: {
    unrealizedPnl: 'Unrealized PnL',
    onCapitalAtRisk: 'on capital at risk',
    positions: 'POSITIONS',
    positionDetails: 'Position Details',
    noOpenTrades: 'No open trades',
    bestPosition: 'Best performing position',
    worstPosition: 'Worst performing position',
    riskAnalysis: 'Risk Analysis',
    highestLoss: 'Highest loss',
    highestGain: 'Highest gain',
    avgPositionProfit: 'Avg position profit',
    weightedAvgProfit: 'Weighted avg profit',
    totalStakeLocked: 'Total stake locked',
    mostLoss: 'Most loss',
    mostGain: 'Most gain',
    durationContext: 'Duration Context',
    avgOpenDuration: 'Avg open duration',
    avgClosedDuration: 'Avg closed duration',
    exceedAvg: 'exceed 2x avg',
    historicalRange: 'Historical range',
    median: 'Median',
  },

  // Closed Profit Card
  closedProfitCard: {
    realizedPerformance: 'Realized Performance',
    loadingBenchmarks: 'Loading benchmark data...',
    noData: 'No profit data available',
    netAfterWithdrawals: 'Net after withdrawals',
    winRateStats: 'Win Rate & Stats',
    totalTrades: 'Total trades',
    avgProfitTrade: 'Avg / trade',
    performanceMetrics: 'Performance Metrics',
    timeAnalysis: 'Time Analysis',
    tradingSpan: 'Trading span',
    avgTradesPerWeek: 'Avg trades / week',
    avgTradesPerMonth: 'Avg trades / month',
    avgProfitWeek: 'Avg profit / week',
    avgProfitMonth: 'Avg profit / month',
    bestPair: 'Best pair',
    withdrawalSummary: 'Withdrawal Summary',
    totalWithdrawn: 'Total withdrawn',
    netProfitAfter: 'Net profit after',
    effectiveRoi: 'Effective ROI',
  },

  // Win/Loss Card
  winLossCard: {
    title: 'Win/Loss Analysis',
    winrate: 'WINRATE',
    wins: 'wins',
    losses: 'losses',
    totalTrades: 'total trades',
    analysis: 'Analysis',
    currentStreak: 'Current streak',
    avgWinLossRatio: 'Avg win/loss ratio',
    avgProfitPerTrade: 'Avg profit / trade',
    profitFactor: 'Profit Factor',
  },

  // Balance Card
  balanceCard: {
    title: 'Balance & Capital',
    startingCapital: 'Starting capital',
    start: 'Start',
    current: 'Current',
    capitalAllocation: 'Capital Allocation',
    inOpenTrades: 'In open trades',
    freeCapital: 'Free capital',
    inTrades: 'In trades',
    free: 'Free',
    openPositions: 'Open positions',
    withdrawals: 'Withdrawals',
    totalWithdrawn: 'Total withdrawn',
    totalDeposited: 'Total deposited',
    currentBalance: 'Current balance',
    summary: 'Summary',
    totalProfit: 'Total profit (all)',
    noWithdrawals: 'No withdrawals',
  },

  // Period Profit Card
  periodProfitCard: {
    title: 'Periodic Profit Analysis',
    loadingBenchmarks: 'Loading benchmark data...',
    noData: 'Not enough data for periodic analysis',
    weeklyAvg: 'Weekly average',
    monthlyAvg: 'Monthly average',
    week: 'week',
    month: 'month',
    dailyBreakdown: 'Daily Breakdown',
    dailyAvg: 'Daily average',
    annualizedReturn: 'Annualized return',
    annualizedCompound: 'Compound return (snowball)',
    compoundProjection: 'Compound projection',
    projections: 'Projections',
    projectionsDisclaimer: 'At current average rate (not guaranteed)',
    months: 'months',
    year: 'year',
    tradingPeriod: 'Trading period',
    days: 'days',
    totalRealized: 'Total realized',
    belowAverage: 'Below avg',
    belowAverageWarning:
      'Recent performance may be below historical average. CAGR suggests decelerating returns.',
    currentMonth: 'Current month',
    currentYear: 'Current year',
    actual: 'Actual',
    projection: 'Projection',
    target: 'Target',
    today: 'Today',
    onTrack: 'On track',
    behind: 'Behind',
    ahead: 'Ahead',
    elapsed: 'elapsed',
    ofTarget: 'of target',
  },

  // Trades Info Card
  tradesInfoCard: {
    positionOverview: 'Position Overview',
    slots: 'SLOTS',
    allocated: 'allocated',
    currentPositions: 'Current Positions',
    inDrawdown: 'in drawdown',
    noOpenPositions: 'No open positions',
    durationAnalysis: 'Duration Analysis',
    avgClosedDuration: 'Avg closed duration',
    longestOpen: 'Longest open',
    anomalyScore: 'Anomaly score',
    stuck: 'Position may be stuck',
    avgDurationLine: 'Average closed trade duration',
    durationTooltip: 'Held {ratio}x longer than average',
    capitalExposure: 'Capital Exposure',
    totalAllocated: 'Total allocated',
    avgStake: 'Avg stake / position',
    largestPosition: 'Largest position',
    winningPositions: 'Winning positions',
    losingPositions: 'Losing positions',
    winning: 'Winning',
    losing: 'Losing',
    free: 'Free',
    tradingRhythm: 'Trading Rhythm',
    perDay: 'Trades / day',
    perWeek: 'Trades / week',
    avgTimeBetween: 'Avg time between',
    sinceLastTrade: 'Since last trade',
    unusuallyQuiet: 'Unusually quiet',
    winRate: 'Win Rate',
    wins: 'wins',
    losses: 'losses',
    total: 'total',
  },

  exchangeCard: {
    type: 'Type',
    founded: 'Founded',
    maxLeverage: 'Max Leverage',
    token: 'Token',
    makerFee: 'Maker Fee',
    takerFee: 'Taker Fee',
    fees: 'Fees',
    headquarters: 'Headquarters',
    kyc: 'KYC',
    hq: 'HQ',
    tradingTypes: 'Trading types',
    freqtradeSupport: 'Freqtrade support',
    exchangeInfoUnavailable: 'Exchange info not available',
    filterByMode: 'Filter bots by {mode}',
  },

  currencyCard: {
    type: 'Type',
    peg: 'Peg',
    peggedTo: 'Pegged to {peg}',
    issuer: 'Issuer',
    backing: 'Backing',
    chain: 'Chain',
    risks: 'Risks',
    botImpact: 'Impact on bot',
    currencyInfoUnavailable: 'Currency info not available',
    filterByCurrency: 'Filter bots by {currency}',
  },

  summaryCard: {
    openTitle: 'Open Profit — All Bots',
    closedTitle: 'Closed Profit — All Bots',
    botRanking: 'Bot Ranking',
    capitalAtRisk: 'Capital at Risk',
    performanceComparison: 'Performance Comparison',
    bestBot: 'Best performing',
    worstBot: 'Worst performing',
    avgRoi: 'Average ROI',
    totalWithdrawals: 'Total withdrawn',
    winrateComparison: 'Win Rate Comparison',
    ofTotal: 'of total',
  },

  summaryWinLoss: {
    title: 'Win / Loss — All Bots',
    overallWinrate: 'Overall Win Rate',
    totalTrades: 'Total closed trades',
    avgWinrate: 'Average win rate',
    bestPerformer: 'Best win rate',
    worstPerformer: 'Lowest win rate',
    outOfTrades: 'out of {count} trades',
  },

  summaryTrades: {
    title: 'All Open Positions',
    positions: 'positions',
    capacity: 'Capacity',
    perBot: 'Per bot',
    capitalExposure: 'Capital exposure',
    multiCurrency: 'Multi-currency',
    perCurrency: 'Per currency',
    allCurrencies: 'All currencies',
    winrateComparison: 'Win Rate Comparison',
    balanceTitle: 'Total Balance — All Bots',
    totalPerCurrency: 'Total per currency',
    ratesSource: 'Rates: CoinGecko',
    ratesUpdated: 'Updated {duration} ago',
    ratesUnavailable: 'Rates unavailable',
    approximateConversion: 'Approximate conversion',
    convertedTotal: 'Converted total',
    conversionRate: 'Rate',
  },

  // Profit metrics
  profit: {
    profitsFor: 'Profits for',
    all: 'All',
    long: 'Long',
    short: 'Short',
    trades: 'Trades',
    metric: 'Metric',
    value: 'Value',
    roiClosed: 'ROI closed trades',
    roiAll: 'ROI all trades',
    totalTradeCount: 'Total Trade count',
    botStarted: 'Bot started',
    firstTradeOpened: 'First Trade opened',
    latestTradeOpened: 'Latest Trade opened',
    winLoss: 'Win / Loss',
    winrate: 'Winrate',
    expectancy: 'Expectancy (ratio)',
    cagr: 'CAGR',
    calmar: 'Calmar',
    sharpe: 'Sharpe',
    sortino: 'Sortino',
    sqn: 'SQN',
    pvalue: 'P-Value',
    avgDuration: 'Avg. Duration',
    bestPerforming: 'Best performing',
    tradingVolume: 'Trading volume',
    profitFactor: 'Profit factor',
    withdrawn: 'Withdrawn',
    netProfit: 'Net Profit (after withdrawals)',
    maxDrawdown: 'Max Drawdown',
    currentDrawdown: 'Current Drawdown',
  },

  // Balance
  balance: {
    title: 'Bot Balance / Account Balance',
    available: 'Available',
    total: 'Total',
    increaseOverCapital: 'Increase over initial capital of',
    currency: 'Currency',
    in: 'in',
    showingAccount: 'Showing Account balance',
    showingBot: 'Showing Bot balance',
    hideSmall: 'Hide small balances',
    showAll: 'Show all balances',
  },

  // Trade list
  tradeList: {
    id: 'ID',
    pair: 'Pair',
    amount: 'Amount',
    stakeAmount: 'Stake amount',
    totalStakeAmount: 'Total stake amount',
    openRate: 'Open rate',
    currentRate: 'Current rate',
    closeRate: 'Close rate',
    currentProfit: 'Current profit %',
    profit: 'Profit %',
    openDate: 'Open date',
    closeDate: 'Close date',
    closeReason: 'Close Reason',
    bot: 'Bot',
    filter: 'Filter',
    noTrades: 'No Trades to show.',
    short: 'Short',
    long: 'Long',
    exitTrade: 'Exit trade',
    cancel: 'Cancel',
    confirm: 'Confirm',
    confirmExit: 'Really exit trade {id} (Pair {pair}) using {orderType} Order?',
    confirmDelete: 'Really delete trade {id} (Pair {pair})?',
    cancelOpenOrder: 'Cancel open order for trade {id} (Pair {pair})?',
    currentlyNoOpen: 'Currently no open trades.',
    noClosedTrades: 'No closed trades so far.',
  },

  // Enhanced trade lists
  enhancedTrades: {
    trades: 'trades',
    filterPlaceholder: 'Filter by pair, bot, tag...',
    columnSettings: 'Column settings',
    colBotState: 'State',
    colBot: 'Bot',
    colTradeId: 'ID',
    colPair: 'Pair',
    colType: 'Type',
    colLeverage: 'Leverage',
    colEntryPrice: 'Entry Price',
    colCurrentPrice: 'Current Price',
    colProfitPct: 'Profit %',
    colProfitAbs: 'Profit',
    colStake: 'Stake',
    colDuration: 'Duration',
    colOpenSince: 'Open Since',
    colOpenReason: 'Open Reason',
    colReplay: 'Replay',
    colStoplossDist: 'Stoploss Dist.',
    colDurationAnomaly: 'Duration Health',
    colDca: 'DCA',
    colOpenDate: 'Open Date',
    colActions: 'Actions',
    colClosePrice: 'Close Price',
    colCloseReason: 'Close Reason',
    colCloseDate: 'Close Date',
    colCloseDuration: 'Hold Duration',
    colClosedAgo: 'Closed Ago',
    colFee: 'Fees',
    durationOk: 'Duration normal (< 24h)',
    durationWarn: 'Duration extended (24-72h)',
    durationDanger: 'Duration critical (> 72h)',
    popoverEntry: 'Entry Price',
    popoverCurrent: 'Current Price',
    popoverClose: 'Close Price',
    popoverProfit: 'Profit',
    popoverDuration: 'Duration',
    popoverStoploss: 'Stoploss',
    popoverLiquidation: 'Liquidation',
    min: 'Min',
    max: 'Max',
    actions: 'Actions',
    actionsFor: 'Actions for {pair}',
    closeActionsMenu: 'Close Actions menu',
    viewChart: 'View chart',
    viewOnExchange: 'View on exchange',
  },

  // Enhanced Log Viewer
  logViewer: {
    levelAll: 'All',
    levelInfo: 'Info',
    levelWarning: 'Warning',
    levelError: 'Error',
    hideHeartbeat: 'Hide heartbeat',
    hideHeartbeatTooltip:
      "Hides periodic bot health check messages (Bot heartbeat PID=..., state=RUNNING). These are normal and don't indicate any issue.",
    hideWebSocket: 'Hide WebSocket',
    hideWebSocketTooltip:
      'Hides WebSocket connection/disconnection messages from the API server. These occur when the FreqUI browser tab connects or disconnects.',
    search: 'Search logs...',
    compact: 'Compact',
    autoScroll: 'Auto-scroll',
    refresh: 'Reload Logs',
    scrollToBottom: 'Scroll to bottom',
    entries: 'entries',
    noEntries: 'No log entries match the current filters.',
  },

  // Trade Detail Popover
  tradePopover: {
    entryPrice: 'Entry Price',
    currentPrice: 'Current Price',
    exitPrice: 'Exit Price',
    profit: 'Profit',
    duration: 'Duration',
    stake: 'Stake',
    entryTag: 'Entry Tag',
    dcaHistory: 'DCA History',
    entries: 'entries',
    entriesNoDetail: 'entries (no order details)',
    priceLevels: 'Price Levels',
    entry: 'Entry',
    current: 'Current',
    exit: 'Exit',
    sl: 'SL',
    liq: 'Liq.',
    stoplossInfo: 'Stoploss Info',
    initialSl: 'Initial SL',
    currentSl: 'Current SL',
    distancePct: 'Distance %',
    stoploss: 'Stoploss',
    liquidation: 'Liquidation',
    exitInfo: 'Exit Info',
    exitReason: 'Exit Reason',
    totalDuration: 'Total Duration',
    durationHealth: 'Duration Health',
    currentDuration: 'Current',
    avgAllDuration: 'Avg (all)',
    avgWinDuration: 'Avg (wins)',
    avgLoseDuration: 'Avg (losses)',
    percentile: 'Percentile',
    fast: 'Fast',
    slow: 'Slow',
  },

  // Duration Health Popover
  durationHealth: {
    title: 'Trade duration vs bot history',
    current: 'Current duration',
    avgAll: 'Avg (all trades)',
    avgWin: 'Avg (winning)',
    avgLose: 'Avg (losing)',
    percentile: 'Percentile',
    sampleSize: 'Based on',
    trades: 'trades',
    fast: 'Fast',
    slow: 'Slow',
    explainClosed: 'This trade is closed. The duration shown is how long the position was held.',
    explainOk: 'This trade duration is within the normal range.',
    explainWarn: 'This trade is taking longer than most. Consider monitoring it closely.',
    explainDanger: 'This trade has been open significantly longer than average. It may be stuck.',
    shortest: 'Shortest trade',
    longest: 'Longest trade',
    loadingBenchmarks: 'Loading benchmark data...',
    noData: 'No closed trade data available for analysis.',
  },

  // Stoploss Chart Popover
  stoplossChart: {
    loading: 'Loading chart...',
    loadingPriceData: 'Loading price data...',
    unavailable: 'Chart unavailable',
    loadingBenchmarks: 'Loading benchmark data...',
    noData: 'No candle data returned',
    fetchError: 'Failed to fetch candle data',
    botNotFound: 'Bot store not found',
    tradeTooOld: 'Trade opened before available candle range',
    entryPrice: 'Entry',
    stoploss: 'Stoploss',
    currentPrice: 'Current',
    liquidation: 'Liquidation',
    dcaEntries: 'DCA entries',
  },

  // Exit Reason Stats Popover
  exitReasonStats: {
    title: 'Exit reason distribution',
    exitReason: 'Exit reason',
    entryTag: 'Entry tag',
    reasonDistribution: 'Exit reasons (all trades)',
    tagDistribution: 'Entry tags (all trades)',
  },

  // Type Stats Popover
  typeStats: {
    title: 'Position type & leverage breakdown',
    long: 'Long',
    short: 'Short',
    count: 'Trades',
    winRate: 'Win rate',
    avgProfit: 'Avg profit',
  },

  // Leverage Stats Popover
  leverageStats: {
    title: 'Leverage Analysis',
    avgLeverage: 'Avg leverage',
    trades: 'trades',
    avg: 'avg',
  },

  // Profit Range Popover
  profitRange: {
    title: 'Profit Range Analysis',
    bestProfit: 'Best Profit',
    worstProfit: 'Worst Profit',
    entry: 'Entry',
    bestLabel: 'Best',
    worstLabel: 'Worst',
    candlesLabel: 'candles',
    noData: 'No candle data available',
  },

  // DCA Info Popover
  dcaInfo: {
    title: 'DCA entries & cost escalation',
    entries: 'entries',
    noDca: 'No DCA orders — single entry',
    lastDca: 'Last DCA',
    price: 'Price',
    amount: 'Amount',
    cost: 'Cost',
    avgBefore: 'Avg before',
    avgAfter: 'Avg after',
    timeAgo: 'Time ago',
    costEscalation: 'Cost escalation per DCA',
    allEntries: 'All entries',
    intervals: 'Intervals',
    totalInvested: 'Total invested',
    avgEntry: 'Avg entry',
    currentRate: 'Current rate',
  },

  // Duration Box Plot Popover
  durationBox: {
    title: 'Duration distribution (all closed trades)',
    median: 'Median',
    thisTrade: 'This trade',
    sample: 'Sample size',
    trades: 'trades',
  },

  // Trade detail
  tradeDetail: {
    general: 'General',
    tradeId: 'Trade Id',
    pair: 'Pair',
    openDate: 'Open date',
    entryTag: 'Entry tag',
    stake: 'Stake',
    totalStake: 'Total Stake',
    amount: 'Amount',
    openRate: 'Open Rate',
    currentRate: 'Current Rate',
    closeRate: 'Close Rate',
    closeDate: 'Close date',
    realizedProfit: 'Realized Profit',
    totalProfit: 'Total Profit',
    currentProfit: 'Current Profit',
    closeProfit: 'Close Profit',
    details: 'Details',
    minRate: 'Min Rate',
    maxRate: 'Max Rate',
    openFees: 'Open-Fees',
    closeFees: 'Fees close',
    stoploss: 'Stoploss',
    atRisk: 'At risk',
    atRiskDesc:
      'The amount at risk based on the stake amount. This is how much you would lose if the stoploss is hit.',
    currentStoplossDist: 'Current stoploss dist',
    initialStoploss: 'Initial Stoploss',
    stoplossLastUpdated: 'Stoploss last updated',
    direction: 'Direction',
    fundingFees: 'Funding fees',
    interestRate: 'Interest rate',
    liquidationPrice: 'Liquidation Price',
    orders: 'Orders',
  },

  // Bot controls
  controls: {
    startTrading: 'Start Trading',
    stopTrading: 'Stop Trading - Also stops handling open trades.',
    pause:
      'Pause (StopBuy) - Freqtrade will continue to handle open trades, but will not enter new trades or increase position sizes.',
    reloadConfig:
      'Reload Config - reloads configuration including strategy, resetting all settings changed on the fly.',
    forceExitAll: 'Force exit all',
    forceEnter:
      'Force enter - Immediately enter a trade at an optional price. Exits are then handled according to strategy rules.',
    stopBot: 'Stop Bot',
    stopBotConfirm: 'Stop the bot loop from running?',
    pauseStopEntering: 'Pause - Stop Entering',
    reload: 'Reload',
    reloadConfirm: 'Reload configuration (including strategy)?',
    forceExitAllConfirm: 'Really forceexit ALL trades?',
  },

  // Force entry form
  forceEntry: {
    title: 'Force entering a trade',
    increasingPosition: 'Increasing position for {pair}',
    orderDirection: 'Order direction (Long or Short)',
    pair: 'Pair',
    price: 'Price [optional]',
    stakeAmount: 'Stake-amount in {stake} [optional]',
    leverage: 'Leverage to apply [optional]',
    orderType: 'OrderType',
    market: 'Market',
    limit: 'Limit',
    entryTag: 'Custom entry tag [optional]',
    cancel: 'Cancel',
    enterPosition: 'Enter Position',
  },

  // Force exit form
  forceExit: {
    title: 'Force exiting a trade',
    exitingTrade: 'Exiting Trade #{id} {pair}.',
    currentlyOwning: 'Currently owning {amount} {currency}',
    amount: 'Amount in {currency} [optional]',
    limitOnly: 'Only available with limit orders',
    orderType: 'OrderType',
    price: 'Price',
    cancel: 'Cancel',
    exitPosition: 'Exit Position',
  },

  // Settings
  settings: {
    title: 'FreqUI Settings',
    uiVersion: 'UI Version',
    uiSettings: 'UI settings',
    language: 'Language',
    lockLayouts: 'Lock dynamic layouts',
    lockLayoutsDesc:
      'Lock dynamic layouts, so they cannot move anymore. Can also be set from the navbar at the top.',
    resetLayout: 'Reset layout',
    resetLayoutDesc: 'Reset dynamic layouts to how they were.',
    showOpenTrades: 'Show open trades in header',
    showOpenTradesDesc: 'Decide if open trades should be visualized',
    utcTimezone: 'UTC Timezone',
    utcTimezoneDesc: 'Select timezone (UTC is recommended as exchanges usually work in UTC)',
    backgroundSync: 'Background sync',
    backgroundSyncDesc: 'Keep background sync running while other bots are selected.',
    confirmDialog: 'Show Confirm Dialog for Trade Exits',
    confirmDialogDesc: 'Use confirmation dialogs when force-exiting a trade.',
    showMultiPaneText: 'Show Text on Multi Pane Buttons',
    showMultiPaneTextDesc: 'Show text on multi pane buttons. If disabled, only shows images.',
    chartSettings: 'Chart settings',
    chartScaleSide: 'Chart scale Side',
    left: 'Left',
    right: 'Right',
    chartScaleDesc: 'Should the scale be displayed on the right or left?',
    heikinAshi: 'Use Heikin Ashi candles',
    heikinAshiDesc: 'Use Heikin Ashi candles in your charts',
    onlyNecessaryColumns: 'Only request necessary columns',
    onlyNecessaryColumnsDesc:
      'Can reduce the transfer size for large dataframes. May require additional calls if the plot config changes.',
    defaultCandles: 'Default number of candles to display (defaults to 250)',
    candleColorPref: 'Candle Color Preference',
    greenUpRedDown: 'Green Up/Red Down',
    greenDownRedUp: 'Green Down/Red Up',
    notificationSettings: 'Notification Settings',
    entryNotifications: 'Entry notifications',
    exitNotifications: 'Exit notifications',
    entryCancelNotifications: 'Entry Cancel notifications',
    exitCancelNotifications: 'Exit Cancel notifications',
    // Browser notifications
    browserNotifications: 'Browser Notifications',
    enableBrowserNotifications: 'Enable browser notifications',
    enableBrowserNotificationsDesc:
      'Receive browser notifications when alerts are triggered (position loss, bot offline, log errors).',
    notificationsDenied:
      'Browser notifications are blocked. Please allow them in your browser settings.',
    notifyPositionLoss: 'Position loss exceeds threshold',
    notifyBotOffline: 'Bot goes offline',
    notifyLogErrors: 'Log errors detected',
    backtestSettings: 'Backtesting settings',
    backtestMetrics: 'Backtesting metrics',
    backtestMetricsDesc: 'Select which metrics should be shown on a per pair / tag basis.',
    // Dashboard section
    dashboardSettings: 'Dashboard',
    // About section
    aboutSection: 'About',
    freqtradeVersion: 'Freqtrade Version',
    credits: 'Built with FreqUI -- Open source trading bot interface',
  },

  // Performance
  performance: {
    title: 'Performance',
    entries: 'Entries',
    exits: 'Exits',
    mixTag: 'Mix Tag',
    pair: 'Pair',
    profitPct: 'Profit %',
    profitStake: 'Profit {stake}',
    count: 'Count',
    enterTag: 'Enter tag',
    exitReason: 'Exit Reason',
  },

  // Pairlist
  pairlist: {
    whitelistMethods: 'Whitelist Methods',
    whitelist: 'Whitelist',
    listUnavailable: 'List Unavailable. Please Login and make sure server is running.',
    blacklist: 'Blacklist',
    blacklistDesc: "Blacklist - Select (followed by a click on '-') to remove pairs",
    addToBlacklist: 'Add Pair to Blacklist',
    selectToDelete: 'Select pairs to delete pairs from your blacklist.',
    pair: 'Pair',
  },

  // Pair Locks
  pairLocks: {
    title: 'Pair Locks',
    pair: 'Pair',
    until: 'Until',
    reason: 'Reason',
    actions: 'Actions',
    deleteLock: 'Delete Lock',
  },

  // Backtesting
  backtest: {
    title: 'Backtesting',
    mustBeWebserver: 'Bot must be in webserver mode to enable Backtesting.',
    loadResults: 'Load Results',
    runBacktest: 'Run backtest',
    analyzeResult: 'Analyze result',
    compareResults: 'Compare results',
    visualizeSummary: 'Visualize summary',
    visualizeResult: 'Visualize result',
    running: 'Backtest running',
    params: 'Backtesting parameters',
    timeframe: 'Timeframe',
    detailTimeframe: 'Detail Timeframe',
    detailTimeframeDesc:
      'Detail timeframe, to simulate intra-candle results. Not setting this will not use this functionality.',
    maxOpenTrades: 'Max open trades',
    useStrategyDefault: 'Use strategy default',
    startingCapital: 'Starting capital',
    useConfigDefault: 'Use config default',
    stakeAmount: 'Stake amount',
    unlimitedStake: 'Unlimited stake',
    enableProtections: 'Enable Protections',
    cacheResults: 'Cache Backtest results',
    enableFreqAI: 'Enable FreqAI',
    enableFreqAIDesc:
      "Assumes freqAI configuration is setup in the configuration, and the strategy is a freqAI strategy. Will fail if that's not the case.",
    freqAIIdentifier: 'FreqAI identifier',
    freqAIModel: 'FreqAI Model',
    summary: 'Backtesting summary',
    resultFor: 'Backtest-result for {strategy}',
    strategySettings: 'Strategy settings',
    setting: 'Setting',
    value: 'Value',
    metrics: 'Metrics',
    resultsPerEnterTag: 'Results per Enter tag',
    resultsPerExitReason: 'Results per Exit reason',
    resultsMixedTag: 'Results Mixed Tag',
    resultsPerPair: 'Results per pair',
    periodicBreakdown: 'Periodic breakdown',
    startBacktest: 'Start backtest',
    loadBacktestResult: 'Load backtest result',
    stopBacktest: 'Stop Backtest',
    resetBacktest: 'Reset Backtest',
    singleTrades: 'Single trades',
    wins: 'Wins',
    draws: 'Draws',
    losses: 'Losses',
    avgProfit: 'Avg Profit %',
    totProfitStake: 'Tot Profit {stake}',
    totProfitPct: 'Tot Profit %',
  },

  // Period breakdown
  periodBreakdown: {
    title: 'Period Breakdown',
    dailyBreakdown: 'Daily Breakdown',
    days: 'Days',
    weeks: 'Weeks',
    months: 'Months',
    years: 'Years',
    weekday: 'Weekday',
    date: 'Date',
    totalProfit: 'Total Profit',
    profitFactor: 'Profit Factor',
    winRate: 'Win Rate',
    absProfit: 'Abs $',
    relProfit: 'Rel %',
    day: 'Day',
    profit: 'Profit',
    inFiat: 'In {currency}',
    trades: 'Trades',
    profitPct: 'Profit%',
  },

  // Download data
  downloadData: {
    title: 'Downloading Data',
    selectPairs: 'Select Pairs',
    pairsFromTemplate: 'Pairs from template',
    addAllPairs:
      'Add all pairs from Pairlist Config - requires the pairlist config to have ran first.',
    selectTimeframes: 'Select timeframes',
    timeSelection: 'Time Selection',
    daysToDownload: 'Days to download',
  },

  // Bot status
  botStatus: {
    running: 'Running Freqtrade',
    runningWith: 'Running with',
    on: 'on',
    in: 'in',
    spot: 'spot',
    markets: 'markets, with Strategy',
    stoplossOnExchange: 'Stoploss on exchange is',
    enabled: 'enabled',
    disabled: 'disabled',
    currently: 'Currently',
    forceEntry: 'force entry',
    dryRun: 'Dry-Run',
    live: 'Live',
    avgProfit: 'Avg Profit',
    tradesAvgDuration: 'Trades, with an average duration of',
    bestPair: 'Best pair',
    botStartDate: 'Bot start date',
    firstTradeOpened: 'First trade opened',
    lastTradeOpened: 'Last trade opened',
    profitFactor: 'Profit factor',
    tradingVolume: 'Trading volume',
    strategyParams: 'Strategy parameters',
  },

  // General
  general: {
    autoRefresh: 'Auto Refresh',
    autoRefreshAll: 'Auto Refresh all bots now',
    supported: 'Supported',
    unsupported: 'Unsupported',
    version: 'Version',
    noBotSelected: 'No bot selected',
    online: 'Online',
    offline: 'Offline',
    starting: 'Starting up...',
    confirmDialogDeactivated:
      'Confirm dialog deactivated, Forced exits will be executed immediately. Be careful.',
  },

  // Trading view
  trading: {
    pairsCombined: 'Pairs combined',
    general: 'General',
    performance: 'Performance',
    balance: 'Balance',
    timeBreakdown: 'Time Breakdown',
    pairlist: 'Pairlist',
    pairLocks: 'Pair Locks',
    openTrades: 'Open Trades',
    closedTrades: 'Closed Trades',
    tradeDetail: 'Trade Detail',
    chart: 'Chart',
    multiPane: 'Multi Pane',
    status: 'Status',
    cache: 'Cache',
    openTradesTitle: 'Open trades',
    tradeHistory: 'Trade history',
  },

  // Charts view
  charts: {
    settings: 'Settings',
    customExchange: 'Custom Exchange',
    currentExchange: 'Current Exchange',
    strategy: 'Strategy',
    useLiveData: 'Use Live Data',
    timeframe: 'Timeframe',
    selectPairs: 'Select pairs to plot',
    refreshChart: 'Refresh chart',
    multiPair: 'Multi pair',
    hideSimultaneous: 'Hide same-candle entries',
    showChartAreas: 'Show Chart Areas',
    heikinAshi: 'Heikin Ashi',
    noPairSelected: 'No pair selected',
    plotConfigurator: 'Plot Configurator',
    useLiveDataHint:
      "Use live data from the exchange. Only use if you don't have data downloaded locally.",
    longEntries: 'Long entries',
    longExits: 'Long exits',
    shortEntries: 'Short entries',
    shortExits: 'Short exits',
    longEntrySignals: 'Long entry signals',
    longExitSignals: 'Long exit signals',
    chartOptions: 'Chart options',
    notLoadedYet: 'Not loaded yet.',
    loading: 'Loading...',
    noData: 'No data available',
    loadError: 'Failed to load data',
    takingLonger: 'This is taking longer than expected...',
    loadStrategyIndicators: 'Load strategy indicators',
    strategyIndicatorsLoaded: 'Indicators loaded',
  },

  // Empty states
  emptyStates: {
    noTradesYet: 'No trades yet',
    noTradesDesc:
      'This bot has not executed any trades yet. Statistics will appear after the first trade.',
    noOpenPositions: 'No open positions',
    noOpenPositionsDesc: 'All clear — no capital currently at risk.',
    noClosedTrades: 'No closed trades',
    noClosedTradesDesc: 'Profit statistics will appear after the first trade closes.',
    noTradingActivity: 'No trading activity',
    noTradingActivityDesc: 'This bot has not recorded any trading activity yet.',
    noWinLossData: 'No win/loss data',
    noWinLossDataDesc: 'Win rate statistics require at least one completed trade.',
    balanceUnavailable: 'Balance unavailable',
    balanceUnavailableDesc: 'Balance data is not available for this bot.',
    insufficientHistory: 'Insufficient history',
    insufficientHistoryDesc: 'Period analysis requires at least a few days of trading history.',
  },

  // Time durations
  time: {
    seconds: '{n} second | {n} seconds',
    minutes: '{n} minute | {n} minutes',
    hours: '{n} hour | {n} hours',
    days: '{n} day | {n} days',
    lessThanMinute: 'less than a minute',
    // Compact "ago" form for tight cells (e.g. BotComparison "Last trade" column)
    justNow: 'just now',
    minutesAgoShort: '{n}m ago',
    hoursAgoShort: '{n}h ago',
    daysAgoShort: '{n}d ago',
  },

  // Metric tooltips
  tooltips: {
    roi: 'Return on Investment - Total profit as percentage of starting capital',
    winrate: 'Percentage of trades that were profitable',
    cagr: 'Compound Annual Growth Rate - Annualized return accounting for compounding',
    sharpe: 'Sharpe Ratio - Risk-adjusted return. Above 1 is good, above 2 is excellent',
    sortino: 'Sortino Ratio - Like Sharpe but only penalizes downside volatility. Higher is better',
    sqn: 'System Quality Number - Measures trading system quality. Above 2 is good, above 3 is excellent',
    expectancy: 'Average expected profit per trade in stake currency',
    profitFactor: 'Ratio of gross profit to gross loss. Above 1 means profitable, above 2 is good',
    maxDrawdown: 'Largest peak-to-trough decline in equity. Lower is better',
    currentDrawdown: 'Current decline from the most recent equity peak',
    avgDuration: 'Average time a trade is held open before closing',
    anomalyScore: 'How much longer the current position is held vs average. Above 2x is a warning',
    tradingVolume: 'Total value of all trades executed',
    calmar:
      'Calmar Ratio - CAGR divided by max drawdown. Higher means better risk-adjusted returns',
    weightedAvgProfit: 'Average profit weighted by position size - larger positions count more',
    annualizedReturn: 'Projected yearly return based on current performance (linear extrapolation)',
    annualizedCompound:
      'Projected yearly return with profit compounding — profits reinvested grow the trading capital (snowball effect). Applies to stake_amount: unlimited.',
    vsBtc:
      'Compares your total profit % with BTC price change % over the same period. Positive = you outperformed simply holding BTC.',
    periodReturn:
      'Total profit earned during the selected time period, both as absolute amount and as percentage of starting capital.',
    capacityUtilization: 'Percentage of maximum allowed positions currently in use',
    avgWinLossRatio: 'Average winning trade size divided by average losing trade size',
    avgProfitPerTrade: 'Mean profit percentage across all closed trades',
    // BotInfoCard
    roiAll: 'Return including both open and closed trades',
    totalTradeCount: 'Total number of trades executed since bot started',
    botStarted: 'Date and time when the bot was first started',
    firstTrade: 'Date of the very first trade executed',
    latestTrade: 'Date of the most recent trade',
    winLoss: 'Number of profitable trades vs losing trades',
    bestPair: 'Trading pair with the highest profit ratio',
    withdrawn: 'Total amount withdrawn from bot profits',
    netProfit: 'Profit after subtracting withdrawals',
    // OpenProfitCard
    unrealizedPnl: 'Total profit/loss on positions not yet closed',
    highestLoss: 'Open position with the largest unrealized loss',
    highestGain: 'Open position with the largest unrealized gain',
    avgPositionProfit: 'Simple average profit across all open positions',
    totalStakeLocked: 'Total capital currently allocated to open positions',
    pctOfBotBalance: 'Percentage of this bot total balance in open positions',
    pctOfAllBots: 'This bot open stake as share of all bots combined',
    durationAnomaly:
      'Compares current hold time to average closed trade duration. Yellow >1.5x, Red >2x',
    // ClosedProfitCard
    realizedProfit: 'Total profit from all closed trades',
    weeklyTrend: 'Weekly profit trend over recent period',
    avgPerTrade: 'Average profit per closed trade',
    tradingPeriod: 'Time span from first to latest trade',
    avgProfitWeek: 'Average profit earned per week',
    avgProfitMonth: 'Average profit earned per month',
    pctOfTotal: 'This bot share of total profit across all selected bots',
    // TradesInfoCard
    capacity: 'How many trade slots are currently used vs maximum allowed',
    capitalAllocation: 'Total stake currency allocated to open positions',
    avgClosedDuration: 'Average time a closed trade was held open',
    tradesPerDay: 'Average number of trades opened per day',
    tradesPerWeek: 'Average number of trades opened per week',
    timeBetweenTrades: 'Average time gap between consecutive trades',
    timeSinceLastTrade: 'Time elapsed since the last trade was opened',
    unusuallyQuiet: 'Trading activity is significantly below average frequency',
    // BalanceCard
    startingCapital: 'Initial capital configured for this bot',
    balanceGrowth: 'Total growth from starting capital to current balance',
    capitalInTrades: 'Amount of balance currently locked in open positions',
    freeCapital: 'Balance available for new trades',
    // PeriodProfitCard
    dailyAvg: 'Average profit earned per day',
    weeklyAvg: 'Average profit earned per week',
    monthlyAvg: 'Average profit earned per month',
    projection1m: 'Estimated profit in 1 month at current rate',
    projection3m: 'Estimated profit in 3 months at current rate',
    projection1y: 'Estimated profit in 1 year at current rate',
    // ExchangeInfoCard
    maxLeverage: 'Maximum leverage available on this exchange',
    makerFee: 'Fee paid when placing limit orders that add liquidity',
    takerFee: 'Fee paid when placing market orders that remove liquidity',
    kycStatus: 'Know Your Customer verification requirements',
    // CurrencyInfoCard
    pegInfo: 'Target value this stablecoin aims to maintain',
    backing: 'Assets backing the value of this currency',
    riskNote: 'Known risks associated with this currency',
    botImpact: 'How this currency affects your bot profit calculations',
    // Alert detailed tooltips
    alertTooltipPositionLoss:
      'Triggers when an open position has an unrealized loss exceeding your threshold. Example: with -10%% threshold and a position at -12%%, the alert fires. If "Include leverage" is checked, a 3x leveraged position at -4%% is treated as -12%%.',
    alertTooltipPositionStuck:
      'Triggers when a position has been held significantly longer than your average trade duration. Example: if your avg trade lasts 8 hours and threshold is 3x, any position open >24 hours triggers.',
    alertTooltipNearLiquidation:
      'Triggers when a futures position is approaching its liquidation price. Example: with 15%% threshold, if price is within 15%% of liquidation, the alert fires.',
    alertTooltipLogErrors: 'Triggers when ERROR or CRITICAL level messages appear in the bot logs.',
    alertTooltipOrderFailed:
      'Triggers when the bot fails to place an order. Often caused by exchange issues or insufficient funds.',
    alertTooltipInsufficientFunds:
      'Triggers when the bot cannot open a position due to lack of funds.',
    alertTooltipExchangeError:
      'Triggers on exchange connectivity issues: timeouts, rate limits, network errors.',
    alertTooltipWalletMismatch:
      'Triggers when the bot detects a mismatch between its tracking and the exchange wallet.',
    alertTooltipNoTradeActivity:
      'Triggers when no new trade has been opened within the configured time.',
    alertTooltipBotOffline: 'Triggers immediately when a bot stops responding.',
    alertTooltipHighDrawdown:
      'Triggers when the current drawdown from peak equity exceeds your threshold.',
    alertTooltipCapacityFull: 'Triggers when all available trade slots are occupied.',
    alertTooltipAllFundsExposed:
      'Triggers when 95%% or more of balance is locked in open positions.',
    alertTooltipLiquidationBeforeStoploss:
      'Triggers when liquidation price is closer than stoploss price. The position would be liquidated before stoploss triggers.',
    // Additional metric tooltips
    currentStreak: 'Number of consecutive wins or losses in a row',
    historicalRange: 'Duration range from shortest to longest closed trade',
    medianDuration: 'Middle value of all closed trade durations, less affected by outliers',
    currentBalance: 'Current total balance of this bot',
    bestBot: 'Bot with the highest return on investment',
    worstBot: 'Bot with the lowest return on investment',
    avgRoiAllBots: 'Average ROI across all selected bots',
    totalWithdrawalsAllBots: 'Sum of all withdrawals across selected bots',
  },

  // Stress Test
  stressTest: {
    title: 'Stress Test',
    estimatedGain: 'Estimated total gain',
    crash: 'crash',
    pump: 'pump',
    scenarioDesc:
      'In case of a sudden and instant market movement, here is what would happen to your current open positions. This assumes a generalized movement where all cryptocurrencies experience the same fluctuation.',
    estimatedImpact: 'Estimated impact',
    estimatedTotalLoss: 'Estimated total loss',
    crashOf: '{pct}% crash',
    pumpOf: '{pct}% pump',
    crashScenario: 'Market crash scenario',
    noOpenPositions: 'No open positions to stress test.',
    noOpenPositionsHint: 'The scenario will apply as soon as a bot opens a trade',
    isolatedOnly:
      'Isolated margin only. Does not account for funding fees, slippage, or cross-margin.',
    liquidation: 'LIQUIDATION',
    liquidationWarning: '{count} position(s) would be liquidated',
  },

  // Profit Goal
  profitGoal: {
    title: 'Goal',
    settings: 'Profit goal settings',
    targetAmount: 'Target amount',
    period: 'Period',
    apply: 'Apply',
    monthly: 'Monthly',
    yearly: 'Yearly',
  },

  // BotInfoCard labels
  botInfoCard: {
    performance: 'Performance',
    timing: 'Timing',
    drawdown: 'Drawdown',
    strategy: 'Strategy',
    exchange: 'Exchange',
    port: 'Port',
    started: 'Started',
    loadingEquity: 'Loading equity data...',
  },

  // AlertDetailCard
  alertDetailCard: {
    alert: 'alert | alerts',
    liquidationDistance: 'Liquidation distance',
    problematicPositions: 'Problematic Positions',
    generalAlerts: 'General Alerts',
    ifClosedNow: 'If closed now',
    stakeAtRisk: 'Stake at risk',
    entry: 'Entry',
    current: 'Current',
    remaining: 'remaining',
    heldFor: 'Held for',
    avgDuration: 'avg',
  },

  // ActivityTimeline
  activityTimeline: {
    ago: '{time} ago',
    justNow: 'just now',
    agoSeconds: '{n}s ago',
    agoMinutes: '{n}m ago',
    agoHours: '{n}h ago',
    agoDays: '{n}d ago',
    searchPlaceholder: 'Search pairs, bots...',
    allBots: 'All bots',
    compactMode: 'Compact mode',
    noEvents: 'No activity yet',
    opened: 'Opened',
    closed: 'Closed',
    long: 'Long',
    short: 'Short',
    entries: 'entries',
    dcaAdjustment: 'DCA adjustment',
    botStatusChange: 'Bot status changed',
    alertTriggered: 'Alert triggered',
    filterOpened: 'Opened',
    filterClosedProfit: 'Profit',
    filterClosedLoss: 'Loss',
    filterDca: 'DCA',
    filterBotStatus: 'Bot',
    filterAlert: 'Alert',
    eventType: {
      trade_opened: 'Trade opened',
      trade_closed_profit: 'Trade closed (profit)',
      trade_closed_loss: 'Trade closed (loss)',
      bot_status: 'Bot status',
      alert: 'Alert',
      dca: 'DCA adjustment',
    },
    goToTradeView: 'Go to Trade view for this bot',
    annotationExceptional: 'Exceptional trade',
    annotationLongDuration: 'Unusually long',
    annotationLargestTrade: 'Largest trade',
    annotationFirstTrade: '(first trade)',
    annotationBestTrade: '(best trade)',
    annotationWorstTrade: '(worst trade)',
    annotationLongestTrade: '(longest trade)',
    allModes: 'All modes',
    liveOnly: 'Live only',
    dryOnly: 'Dry only',
    compactLabel: 'Compact',
    group: {
      today: 'Today',
      yesterday: 'Yesterday',
      thisWeek: 'This week',
      earlier: 'Earlier',
    },
  },

  // Trades Log Enhanced
  tradesLog: {
    allBots: 'All bots',
    filterAll: 'All',
    filterOpens: 'Opens',
    filterCloses: 'Closes',
    noEntries: 'No trade events yet',
    opened: 'opened',
    statTotal: 'Total',
    statOpens: 'Opens',
    statWins: 'Wins',
    statLosses: 'Losses',
  },

  // Market & Performance Overview
  marketPulse: {
    // Timeframes
    tf_today: 'Today',
    tf_24h: '24h',
    tf_7d: '7 days',
    tf_thisWeek: 'This week',
    tf_30d: '30 days',
    tf_thisMonth: 'This month',
    tf_thisYear: 'This year',
    tf_1y: '1 year',
    // Settings
    settings: 'Settings',
    defaultTimeframe: 'Default timeframe',
    sectionMarket: 'Market indicators',
    sectionPerformance: 'Bot performance',
    sectionVolume: 'Volume',
    sectionComparison: 'Comparison',
    // Market
    fearGreed: 'Fear & Greed',
    extremeFear: 'Extreme Fear',
    fear: 'Fear',
    greed: 'Greed',
    extremeGreed: 'Extreme Greed',
    // Performance
    botPerformance: 'Bot Performance',
    totalProfit: 'Total Profit',
    trades: 'Trades',
    winRate: 'Win Rate',
    bestTrade: 'Best Trade',
    worstTrade: 'Worst Trade',
    bestBot: 'Best Bot',
    worstBot: 'Worst Bot',
    // Volume
    volume: 'Volume',
    volumeByExchange: 'By exchange',
    volumeByCurrency: 'By currency',
    // Comparison
    comparison: 'Comparison',
    yourBots: 'Your Bots',
    beatingBtc: 'Beating BTC!',
    underperformingBtc: 'Underperforming BTC',
    // Popovers
    popoverBtcTitle: 'Bitcoin Price',
    popoverPrice: 'Price',
    popover24hChange: '24h Change',
    popover7dChange: '7d Change',
    popoverSource: 'Source',
    popoverFgTitle: 'Fear & Greed Index',
    popoverFgDescription:
      'Measures market sentiment from 0 (extreme fear) to 100 (extreme greed). Based on volatility, volume, social media, surveys, dominance and trends.',
    popoverPerf_totalProfit: 'Total Profit',
    popoverPerfDesc_totalProfit:
      'Sum of all closed trade profits in the selected period, converted to the summary currency.',
    popoverPerf_trades: 'Trade Count',
    popoverPerfDesc_trades:
      'Total number of trades closed in the selected period across all selected bots.',
    popoverPerf_winRate: 'Win Rate',
    popoverPerfDesc_winRate:
      'Percentage of profitable trades (profit > 0) among all closed trades in the selected period.',
    popoverPerf_bestTrade: 'Best Trade',
    popoverPerfDesc_bestTrade:
      'The single trade with the highest profit ratio in the selected period.',
    popoverPerf_worstTrade: 'Worst Trade',
    popoverPerfDesc_worstTrade:
      'The single trade with the lowest profit ratio in the selected period.',
    popoverPerf_bestBot: 'Best Bot',
    popoverPerfDesc_bestBot:
      'The bot with the highest total absolute profit in the selected period.',
    popoverPerf_worstBot: 'Worst Bot',
    popoverPerfDesc_worstBot:
      'The bot with the lowest total absolute profit in the selected period.',
  },

  // Performance Heatmap
  performanceHeatmap: {
    loadingBenchmarks: 'Loading benchmark data...',
    noData: 'No trade data available',
    profit: 'Profit',
    loss: 'Loss',
    tf_day: 'Per day',
    tf_week: 'Per week',
    tf_month: 'Per month',
  },

  // Risk Overview
  riskOverview: {
    totalExposure: 'Total Exposure',
    netExposure: 'Net Exposure',
    grossExposure: 'Gross Exposure',
    currentExposure: 'Current Exposure',
    deployed: 'deployed',
    of: 'of',
    longLabel: 'Long',
    shortLabel: 'Short',
    avgLeverage: 'Avg Leverage',
    largestPosition: 'Largest Position',
    worstDrawdown: 'Worst Drawdown',
    overallPnl: 'Overall Open PnL',
    correlationWarnings: 'Correlation Warnings',
    // Popovers
    popoverExposureTitle: 'Exposure Breakdown',
    popoverExposureDesc: 'Capital currently deployed in open positions, broken down by bot.',
    popoverDrawdownTitle: 'Worst Drawdown',
    popoverDrawdownDesc: 'The open position with the largest unrealized loss percentage.',
    popoverDrawdownPair: 'Pair',
    popoverDrawdownPct: 'Drawdown',
    popoverDrawdownBot: 'Bot',
    popoverPnlTitle: 'Open PnL Breakdown',
    popoverPnlDesc: 'Unrealized profit/loss of all open positions, broken down by bot.',
    popoverLeverageTitle: 'Leverage Detail',
    popoverLeverageDesc: 'Average leverage used by each bot across open positions.',
    popoverCorrelationTitle: 'Correlation Warnings',
    popoverCorrelationDesc:
      'Pairs traded simultaneously by multiple bots, increasing correlated risk.',
    popoverCorrelationNone: 'No correlated pairs detected.',
    totalBalanceTooltip: 'Total balance across all selected bots',
    riskLow: 'Low Risk',
    riskModerate: 'Moderate Risk',
    riskHigh: 'High Risk',
    noOpenPositions: 'No open positions',
    noOpenPositionsHint: 'Risk metrics will appear as soon as a bot opens a trade',
  },

  // Fleet view
  fleet: {
    title: 'Fleet',
    servedBy: 'served by {bot}',
    refresh: 'Refresh',
    loading: 'Loading fleet data...',
    walletReconciliation: 'Fleet · Wallet reconciliation',
    allClear: 'all clear',
    issueCount: '{count} issue(s)',
    directionalExposure: 'Fleet · Directional exposure',
    pnlContribution: 'Fleet · P&L contribution',
    botsPanel: 'Fleet · Bots',
    reconciliationDesc:
      'Compares on-chain wallet positions with the sum of all bot databases. Server-side aggregate, refreshes every 60s.',
    exposureDesc:
      'Net long/short exposure of the whole fleet. Server-side aggregate, refreshes every 60s.',
    pnlDesc:
      'P&L contribution per bot across the whole fleet. Server-side aggregate, refreshes every 60s.',
    botsDesc:
      'All fleet bots with capital, P&L and activity. Server-side aggregate, refreshes every 60s.',
    errors: {
      overviewFailed: 'Failed to load fleet overview',
      reconciliationFailed: 'Failed to load reconciliation',
      noServingBot:
        'No connected bot supports FleetView. Restart at least one bot with the updated backend.',
      servingBotUnavailable: 'FleetView serving bot unavailable.',
      resolveFailed: 'Resolve request failed',
    },
    botsTable: {
      botCount: '{count} bots',
      capital: 'Capital',
      label1d: '1d',
      label7d: '7d',
      label30d: '30d',
      total: 'Total',
      open: 'Open',
      filterPlaceholder: 'Filter bot / strategy',
      modeLive: 'Live',
      modeDry: 'Dry',
      modeAll: 'All',
      colBot: 'Bot',
      colStrategy: 'Strategy',
      colDirection: 'Dir',
      colCapital: 'Capital',
      colPnl1d: 'P&L 1d',
      colOpen: 'Open',
      colTrades30d: 'Trades 30d',
      colUptime: 'Uptime',
      colAge: 'Age',
      colPort: 'Port',
      dryTag: 'DRY',
      frozenTitle: 'Frozen (effective capital <= 0)',
      inertTitle: 'Inert (no trade in 14d)',
      leverageTitle: 'Leverage {leverage}x',
      dbUnreadable: 'Database unreadable',
      durationM: '{m}m',
      durationHM: '{h}h {m}m',
      durationDH: '{d}d {h}h',
    },
    pnl: {
      includeUpnl: 'include uPnL (approx)',
      sum: 'Sum:',
      nonZeroBots: '{count} bots with non-zero contribution',
      noContribution: 'No contribution in this window.',
      window1d: '1d',
      window7d: '7d',
      window30d: '30d',
    },
    exposure: {
      long: 'Long',
      short: 'Short',
      longWord: 'long',
      shortWord: 'short',
      allocatedStake: '(allocated stake, {total} USDC)',
      topNet: 'Top net on-chain exposures',
      walletNet: 'Wallet net:',
      upnlTitle: 'uPnL {upnl} USDC',
      noPosition: 'No on-chain position.',
    },
    reconciliation: {
      liveBots: '{count} live bots',
      secondsAgo: '{seconds}s ago',
      minutesAgo: '{minutes}m ago',
      noData: 'No reconciliation data.',
      mark: 'mark {price}',
      upnl: 'uPnL',
      dbSays: 'DB says',
      onChain: 'On-chain',
      gap: 'Gap',
      sideFlat: 'flat',
      sideLong: 'long',
      sideShort: 'short',
      summaryMinority:
        'DB and wallet agree on the total ({chainSide} {chainAmount} {coin}), but {bot} #{tradeId} holds the opposite side of the net position: its exits are rejected as reduce-only.',
      summaryPhantom:
        'The share of {bot} #{tradeId} does not exist on-chain: the wallet holds {chainSide} {chainAmount} {coin}, fully accounted for by the other bots. Deleting it from the DB is safe (no exchange order).',
      summaryUnowned:
        'The wallet holds {chainSide} {chainAmount} {coin} but no bot claims this position.',
      summaryAmbiguous:
        'Bots collectively claim {dbSide} {dbAmount} {coin} but wallet holds {chainSide} {chainAmount} (gap {gap}). No single trade explains the gap: see the resolution guide.',
      status: {
        phantom: 'phantom',
        minority: 'minority',
        unowned: 'unowned',
        ambiguous: 'ambiguous',
      },
      hint: {
        phantom:
          'A bot holds a trade whose share is provably absent on-chain. Safe to delete from its DB (no exchange order).',
        minority:
          'DB matches on-chain, but one bot holds the OPPOSITE side of the net position. Its exits are rejected (reduce-only).',
        unowned:
          'On-chain position with no owning bot in any DB. Can be flattened with a reduce-only order.',
        ambiguous:
          'DB and on-chain disagree with no single provable cause. Manual investigation required.',
      },
      colBot: 'Bot',
      colTrade: 'Trade',
      colSignedAmount: 'Signed amount',
      colOpenRate: 'Open rate',
      colStake: 'Stake',
      closeMinority: 'Close minority slice',
      deletePhantom: 'Delete phantom trade ({bot} #{tradeId})',
      flattenReduceOnly: 'Flatten (reduce-only)',
      manualOnly: 'Manual intervention required, no automatic action available.',
      allInSync: 'DB and on-chain positions are in sync.',
      coinsInSync: '{count} coins in sync',
      guide: {
        title: 'Resolution guide',
        refreshNow: 'Refresh now',
        refreshFirst:
          'Refresh twice ~1 min apart. If the gap moves or disappears it was an in-flight order: do nothing.',
        dust: 'Gap is dust (~{notional} USDC). Safe to ignore. Optionally flatten manually with a reduce-only order.',
        multiPhantom:
          "{count} trades are each a possible phantom. Cross-check each bot's exchange fill history: the real phantom is the one whose side is absent on-chain. Delete only that one (DB delete, no order).",
        multiPhantomItem: '{bot} #{tradeId} ({amount})',
        partialFill:
          "Likely unrecorded partial fill: {bot} trade #{tradeId} recorded {dbAmount} but on-chain math implies only {impliedFill} was actually filled. Check the trade's exchange fills, then fix the DB amount, or apply the minority playbook (stop bot, inverse order without reduce-only, close trade in DB, relaunch).",
        staleDb:
          "Nothing reconciles: probably a stopped bot whose DB still holds open trades (not visible to this scan). Check recently stopped bots' databases before touching anything.",
        footer:
          'Never touch strategies or leverage to fix netting issues. Re-check with a forced refresh after any action.',
      },
      dialog: {
        deletePhantomTitle: 'Delete phantom trade on {coin}',
        closeMinorityTitle: 'Close minority slice on {coin}',
        flattenUnownedTitle: 'Flatten unowned position on {coin}',
        warnDeletePhantom:
          'The trade will be removed from the bot database. No exchange order is placed.',
        warnCloseMinority:
          'A market order WITHOUT reduce-only will be placed to realign the wallet, then the stuck trade is deleted from the bot database. The P&L of this trade will NOT be recorded in the bot statistics.',
        warnFlattenUnowned:
          'A reduce-only market order will be placed to flatten the on-chain position. Reduce-only can only shrink the position, never flip it.',
        coin: 'Coin',
        bot: 'Bot',
        trade: 'Trade',
        amount: 'Amount',
        estNotional: 'Est. notional',
        done: 'Done',
        orderResult: "Order {id}: filled {filled} {'@'} {avg} ({notional} USDC)",
        dbDelete: 'DB delete:',
        close: 'Close',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      realign: {
        button: 'Realign DB',
        title: 'Realign DB on on-chain, {coin}',
        dbOnly:
          'DB-only action: no exchange order will ever be placed. Only the bot databases are rewritten to match the on-chain position.',
        intro:
          'Choose what to do with each DB share so their sum matches the on-chain net position. At most one share can be adjusted; closed shares are removed entirely.',
        colAction: 'Action',
        colNewAmount: 'New amount',
        keep: 'Keep',
        closeOp: 'Close',
        adjustOp: 'Adjust',
        onlyOneAdjust: 'Only one share can be adjusted per plan.',
        resulting: 'Resulting sum:',
        target: 'On-chain target:',
        withinTolerance: 'match (2%)',
        outsideTolerance: 'no match',
        previewBtn: 'Preview',
        colBefore: 'Before',
        colAfter: 'After',
        colDelta: 'Delta',
        colNotional: 'Delta notional',
        touchedNotional: 'Touched notional: {notional} USDC',
        backBtn: 'Back',
        applyBtn: 'Apply (DB only)',
        resultsTitle: 'Results',
      },
    },
  },

  // Summary cards
  summaryCards: {
    bots: 'bots',
    shareOfTotalProfit: 'Share of total profit',
    profitOfTotal: '{profit} out of {total} (all bots)',
    pctOfBotBalance: '% of this bot balance',
    pctOfAllBotsOpenPositions: '% of open positions (all bots)',
  },

  // Log Console Widget
  logWidget: {
    allClear: 'All clear',
    grouped: 'Grouped',
    timeline: 'Timeline',
    compact: 'Compact',
    hideHB: 'Hide HB',
    hideWS: 'Hide WS',
    hideWallet: 'Hide Wallet',
    filters: 'Filters',
    resetFilters: 'Reset filters',
    unreachableBots: 'Unreachable bots',
    fetchingLogs: 'Fetching logs from {count} bots...',
    allBotsOk: 'All {count} bots running without issues',
    noMatch: 'No log entries match the current filters',
    showing: 'Showing {shown} of {total} entries',
    moreBots: '+{count} more bots...',
    showLess: 'Show less',
    botsWithoutIssues: '{count} bot(s) without issues',
    offline: 'offline',
    issues: 'issues',
    bots: 'Bots',
    mode: 'Mode',
    market: 'Market',
    currency: 'Currency',
    tags: 'Tags',
    source: 'Source',
  },

  // Chart Popover
  chartPopoverTitle: 'Price levels & zones',

  // Trade Detail Popover
  tradeOverview: 'Trade overview',

  // Correlation / Double Exposure
  corrPopover: {
    doubleExposure: 'Double exposure detected',
    combinedMargin: 'Combined margin',
    combinedNotional: 'Combined notional',
    direction: 'Direction',
    sameDirection: 'Same (amplified risk)',
    oppositeDirection: 'Opposite (hedged)',
    warningSame:
      'Both bots are trading in the same direction. A price move against you affects all positions simultaneously — your actual risk is the sum of all margins, not what each bot calculates individually.',
    warningOpposite:
      'Bots are trading in opposite directions (one long, one short). This partially hedges the risk but you pay fees on both sides.',
    dismiss: 'Dismiss',
    tradedBy: 'traded by {bots} (double exposure)',
    notFilterable: 'Not filterable by date',
  },

  // Config Export/Import
  configExport: {
    title: 'FreqUI Config',
    export: 'Export configuration',
    import: 'Import configuration',
    importing: 'Importing...',
    restored: '{keys} settings restored, {bots} bots',
    reloading: 'Reloading...',
    importDesc:
      'Have a saved FreqUI configuration? Import it to restore your bots, layout, and preferences.',
    saves: 'Saves: bots, layout, filters, theme, alerts, benchmarks',
    exportPng: 'Export as PNG',
  },

  // Bot List Collapsible
  botList: {
    showLess: 'Show less',
    moreBots: '+{count} more...',
    title: 'Available bots',
    searchPlaceholder: 'Search bots…',
    addBot: 'Add new bot',
    addFirstBot: 'Add your first bot',
    emptyState: 'No bots connected yet. Add one to start trading.',
    viewFlat: 'Switch to flat list',
    viewGrouped: 'Group by folder',
    noMatches: 'No bots match your filters.',
    autoRefresh: 'Auto-refresh',
    onlineSince: 'up {duration}',
    dry: 'Dry',
    live: 'Live',
    dryTooltip: 'Dry-run mode — simulated trades, no real money.',
    liveTooltip: 'Live mode — trading with real funds.',
    spotTooltip: 'Spot: buy and sell only, no leverage or shorting.',
    futuresTooltip: 'Futures: supports short, long, and leverage trading.',
    sort: {
      manual: 'Manual order',
      name: 'Name (A→Z)',
      oldest: 'Oldest first',
      newest: 'Newest first',
      status: 'Status',
      mode: 'Mode',
    },
    filter: {
      all: 'All',
      live: 'Live',
      dry: 'Dry',
      offline: 'Offline',
    },
    // Folders
    ungrouped: 'Ungrouped',
    noFolder: 'No folder',
    changeFolder: 'Change folder',
    moveToFolder: 'Move to folder',
    removeFromFolder: 'Remove from folder',
    noFoldersYet: 'No folders yet — create one below.',
    newFolder: 'New folder',
    newFolderName: 'Folder name',
    createFolder: 'Create folder',
    renameFolder: 'Rename folder',
    deleteFolder: 'Delete folder',
    emptyFolder: 'Empty — move a bot here.',
  },

  // Rate Monitor widgets
  rateMonitor: {
    rateBudget: 'Rate Budget',
    rateBudgetDesc:
      'Rate limit budget — shows how many tokens are available for API calls. 100% = full budget, each request consumes tokens, they refill over time. Below 30% = risk of 429 rate-limiting.',
    tokenBucket: 'Token Bucket — Rate Limit Budget',
    tokenBucketAvail: 'Available: {avail} / {max} tokens',
    tokenBucketFill: 'Fill level: {pct}%',
    tokenBucketExplain:
      'Each API call consumes tokens. They refill automatically over time. When empty, requests are queued or throttled to avoid 429 errors.',
    tokenBucketLow: 'Low budget — risk of rate-limiting',
    requests: 'Requests',
    requestsDesc: 'Total API calls sent to the exchange in the current window (direct + cached)',
    errors: 'Errors',
    errorsDesc:
      'Failed requests — includes timeouts, server errors, and network failures (excludes 429s counted separately)',
    avgResponse: 'Avg',
    avgResponseDesc:
      'Average API response time — how long the exchange takes to respond to direct (non-cached) requests',
    p95Response: 'P95',
    p95ResponseDesc:
      '95th percentile response time — 95% of requests are faster than this. High values indicate occasional slow responses from the exchange.',
    queue: 'Queue',
    queueDesc:
      'Requests currently waiting in the rate-limiter queue — high values mean the bot is sending more requests than the exchange allows',
    exchange: 'Exchange',
    exchangeDesc: 'The exchange this bot is connected to',
    rateLimitHits: '{count} rate-limit hit | {count} rate-limit hits',
    backoff: 'Backoff x{factor} — {remaining}s left',
    backoffDesc:
      'Exponential backoff is active — requests are being slowed down to recover from rate-limiting',
    cacheHitRates: 'Cache Hit Rates',
    cacheHitRatesDesc:
      'Percentage of requests served from local cache instead of hitting the exchange API. Higher = fewer exchange calls = less rate-limit pressure.',
    ohlcvDesc:
      'Candlestick data (Open/High/Low/Close/Volume) served from cache vs fetched from exchange',
    tickersDesc: 'Live price tickers served from cache vs fetched from exchange',
    positionsDesc: 'Open position data served from cache vs fetched from exchange',
    lowCacheEfficiency: 'Low cache efficiency — more direct exchange calls',
    topMethods: 'Top Methods',
    topMethodsDesc:
      'Top API methods by call count — shows which exchange endpoints are called most frequently',
    method: 'Method',
    count: 'Count',
    cached: 'Cached',
    perBot: 'Per Bot',
    noMetrics: 'No rate metrics available',
    noMetricsHint: 'Bot must be running to collect data',
    window: 'Window',
    methods: '{count} methods',
    flow: 'Flow',
    table: 'Table',
    noFlowData: 'Not enough data for flow diagram',
    noMethodData: 'No method data available',
    waitingActivity: 'Waiting for API activity',
    noTimeline: 'No timeline data',
    responseTime: 'Response Time',
    avgResponseTime: 'Average API response time across all methods',
    direct: 'Direct (API)',
    directDesc: 'Requests sent directly to the exchange API',
    cachedDesc: 'Requests served from local cache without hitting the exchange',
    errorsChartDesc: 'Failed requests shown as bars',
    req: 'req',
    '429s': '429s',
  },

  // Cache Health widget
  cacheHealth: {
    title: 'Cache Health',
    hitRate: 'Hit rate',
    totalRequests: 'Total requests',
    cacheHits: 'Cache hits',
    cacheMisses: 'Cache misses',
    gets: 'Gets',
    hits: 'Hits',
    puts: 'Puts',
    entries: 'Entries',
    clients: 'Clients',
    cached: 'Cached',
    cachedFtcache: 'Cached (ftcache)',
    cachedFtpairlist: 'Cached (ftpairlist)',
    directToExchange: 'Direct to exchange',
    breakdown: 'Request Breakdown',
    breakdownDesc: 'How requests are split between cache layers and direct exchange calls',
    exchangeCapacity: 'Exchange Capacity',
    capacityDesc:
      'Direct API calls vs exchange rate limit capacity. High values indicate the bot is close to the rate limit.',
    directLoad: 'Direct API load',
    exchangeMax: 'Exchange max',
    ftcacheExplain:
      'ftcache: local OHLCV/ticker/position cache daemon that reduces exchange API calls by serving repeated data from memory',
    ftpairlistExplain:
      'ftpairlist: shared pairlist cache daemon that avoids redundant pairlist fetches across multiple bot instances',
    entriesDesc: 'Number of cached pairlist entries currently stored',
    clientsDesc: 'Number of bot instances currently connected to the pairlist cache',
    gaugeExplain0: '0% = no requests served from cache (all going directly to exchange)',
    gaugeExplain100: '100% = all requests served from cache (no direct exchange calls)',
    noData: 'No cache data available',
    noDataHint: 'Cache daemons must be running',
  },

  // Infrastructure Health widget (consolidated FleetOverview + CacheStatus)
  infraHealth: {
    title: 'Infrastructure',
    bot: 'Bot',
    state: 'State',
    pairs: 'Pairs',
    uptime: 'Uptime',
    hb: 'HB',
    events: 'Events',
  },

  // Strategy Development Center
  strategyDev: {
    title: 'Strategy Development',
    noRunSelected: 'Select a run from the sidebar to view details.',
    selectRunHint: 'Select a run from the sidebar to view details',
    shortcutSearch: 'Search runs',
    shortcutSidebar: 'Toggle sidebar',
    shortcutNavigate: 'Navigate runs',
    shortcutDeselect: 'Deselect run',
    noRuns: 'No runs found.',
    loading: 'Loading runs...',
    search: 'Search strategies...',
    allTypes: 'All',
    groupByType: 'By type',
    groupByStrategy: 'By strategy',
    allStrategies: 'All strategies',
    filterByType: 'Filter by type',
    filterByStrategy: 'Filter by strategy',
    filterByDate: 'Filter by date',
    dateAll: 'All time',
    date24h: 'Last 24h',
    date48h: 'Last 48h',
    date7d: 'Last 7 days',
    date14d: 'Last 14 days',
    date30d: 'Last 30 days',
    date3m: 'Last 3 months',
    date6m: 'Last 6 months',
    date1y: 'Last year',

    // Run types
    backtest: 'Backtest',
    hyperopt: 'Hyperopt',
    wfa: 'Walk-Forward',
    liveBots: 'Bots',

    // Live bot
    liveScorecardTitle: 'Live Results',
    liveSimBanner: '{count} open trade(s) simulated as closed at current price',
    liveRefresh: 'Refresh',
    liveBotInfo: 'Bot Info',
    liveSummary: 'Performance Summary',
    liveExchange: 'Exchange',
    liveMode: 'Mode',
    liveDryRun: 'Dry Run',
    liveReal: 'Live',
    liveTimeframe: 'Timeframe',
    liveMaxTrades: 'Max Trades',
    liveNoTrades: 'No trades available for this bot.',

    // Job Launcher
    jobLaunch: 'Launch Job',
    jobTypeLabel: 'Job Type',
    jobBaseConfig: 'Base Configuration',
    jobConfig: 'Config File',
    jobSelectConfig: 'Select a config...',
    jobStrategy: 'Strategy',
    jobSelectStrategy: 'Select a strategy...',
    jobDateFrom: 'Start Date',
    jobDateTo: 'End Date',
    jobTimerange: 'Timerange',
    jobTimeframe: 'Timeframe',
    jobTimeframeDesc:
      'Candle timeframe for the strategy. Overrides config value. E.g. 15m for scalping, 1h for swing. Strategy must be designed for this timeframe.',
    jobMaxOpenTrades: 'Max Open Trades',
    jobMaxOpenTradesDesc:
      'Max simultaneous open positions. Overrides config. E.g. 3 = max 3 trades at once. Directly impacts capital exposure (stake × MOT).',
    jobStakeAmount: 'Stake Amount',
    jobStakeAmountDesc:
      'Amount per trade in stake currency. Values: number (e.g. 100), "unlimited" (dynamic sizing via custom_stake_amount). Overrides config.',
    jobDryRunWallet: 'Dry Run Wallet',
    jobDryRunWalletDesc:
      'Simulated starting balance in USDT. E.g. 1000 = simulate with 1000 USDT. Defines portfolio size for position sizing and drawdown calculation.',
    jobEnableProtections: 'Protections',
    jobEnableProtectionsDesc:
      'Enable strategy protections (CooldownPeriod, StoplossGuard, MaxDrawdown, etc.). Slower but simulates real bot behavior.',
    // Common advanced
    jobAdvancedParams: 'Advanced Parameters',
    jobDataFormat: 'Data Format',
    jobDataFormatDesc:
      'OHLCV storage format on disk. feather (default) = fast and compact. parquet = Spark/BigQuery compatible. json/jsongz = human-readable.',
    jobFee: 'Fee',
    jobFeeDesc:
      'Fee ratio applied on entry AND exit. E.g. 0.001 = 0.1% per trade (0.2% round-trip). Leave empty = use exchange fees (recommended).',
    jobPairs: 'Pairs',
    jobPairsDesc:
      'Limit to specific pairs, comma-separated. E.g. BTC/USDT:USDT, ETH/USDT:USDT. Ignores config pairlist. Useful for single-pair testing.',
    jobPositionStacking: 'Position Stacking',
    jobPositionStackingDesc:
      "Allow multiple positions on the same pair (DCA). Warning: results not reproducible in live if bot doesn't support stacking.",
    jobTimeframeDetail: 'Detail Timeframe',
    jobTimeframeDetailDesc:
      'Sub-candle resolution for intra-candle entry/exit simulation. E.g. timeframe=1h + detail=5m → simulates 5m price movement within each 1h candle. Slower but more precise.',
    // Backtest-only
    jobBacktestParams: 'Backtest Parameters',
    jobExportType: 'Export',
    jobExportTypeDesc:
      'Data exported in result file. trades (default) = trade list. signals = trades + buy/sell signals per candle. none = no export.',
    jobBreakdown: 'Breakdown',
    jobBreakdownDesc:
      'Break down results by time period. day = profit/day, week = profit/week, month = profit/month. Helps identify underperformance periods.',
    jobCache: 'Cache',
    jobCacheDesc:
      'Reuse cached results if last run is younger than N. day (default) = 24h. none = force recalculation. Useful for quick iteration without re-running.',
    jobDynamicPairlist: 'Dynamic Pairlist',
    jobDynamicPairlistDesc:
      'Refresh pairlist each new candle (e.g. VolumePairList recalculated). More realistic but much slower. Required if your pairlist filters by recent volume.',
    jobNotes: 'Notes',
    jobNotesDesc:
      'Free text saved in the result file. E.g. "Test without SL with new DCA". Visible in run history.',
    // Hyperopt params
    jobHyperoptParams: 'Hyperopt Parameters',
    jobEpochs: 'Epochs',
    jobEpochsDesc:
      'Number of parameter combinations tested. 300-500 = initial exploration. 1000+ = fine optimization. More epochs = better results but longer. Time ≈ epochs × backtest_duration / workers.',
    jobLoss: 'Loss Function',
    jobLossDesc:
      'Defines what "better" means. CalmarHyperOptLoss = profit/max drawdown (DCA). SharpeHyperOptLoss = risk-adjusted return (momentum). MoutonMeanRev = custom DCA/mean-reversion. SortinoHyperOptLoss = penalizes downside volatility only.',
    jobSampler: 'Sampler',
    jobSamplerAuto: 'Auto (default)',
    jobSamplerDesc:
      'Exploration algorithm. NSGA-III (default) = genetic, good diversity, best for multi-metric. TPE = bayesian, fast convergence, best for 300-500 epochs + simple loss. CMA-ES = gradient-free for continuous params. GP = gaussian, slow if >10 params.',
    jobSpaces: 'Spaces',
    jobSpacesDesc:
      'Parameter spaces to optimize. default = buy+sell+roi+stoploss. all = everything. Multiple selection possible. buy/sell = entry/exit signals. roi/stoploss/trailing = ROI table and stops.',
    jobEarlyStop: 'Early Stop',
    jobEarlyStopDesc:
      'Stop if no improvement after N epochs. E.g. 150 = stop after 150 epochs with no progress. Good value: 20-30% of total epochs. 0 = disabled. Too low = premature stop.',
    jobMinTrades: 'Min Trades',
    jobMinTradesDesc:
      'Epochs with fewer than N trades get max loss (worst score). E.g. 30 = min 30 trades to be evaluated. <30 = statistically unreliable. Set to 50-100 for robust results.',
    jobWorkers: 'Workers',
    jobWorkersDesc:
      'Parallel processes. -1 = all CPUs (fastest, high RAM). -2 = all minus one (system headroom). 1 = sequential (debug/low RAM). Each worker loads full data copy → RAM × workers.',
    jobRandomState: 'Random State',
    jobRandomStateDesc:
      'Fix random seed for reproducible results. E.g. 42. Without seed, each run explores different combinations. Useful for comparing loss functions or samplers.',
    jobPrintAll: 'Print All',
    jobPrintAllDesc:
      'Print all results in logs, not just the best. Useful for analyzing result distribution and detecting overfitting.',
    jobDisableParamExport: 'Disable Param Export',
    jobDisableParamExportDesc:
      "Don't auto-create Strategy.json with best params. Useful to compare before overwriting existing params.",
    jobIgnoreMissingSpaces: 'Ignore Missing Spaces',
    jobIgnoreMissingSpacesDesc:
      'Suppress errors if a requested space has no optimizable parameters. E.g. --spaces trailing but strategy has no trailing params.',
    jobAnalyzePerEpoch: 'Analyze Per Epoch',
    jobAnalyzePerEpochDesc:
      'Rerun populate_indicators() each epoch instead of once. Required if indicators depend on hyperparameters. Much slower.',
    // WFA params
    jobWfaParams: 'Walk-Forward Parameters',
    jobWfWindows: 'Windows',
    jobWfWindowsDesc:
      'Number of train/test windows. 3-5 for 1-2 years of data, 5-8 for 3+ years. More windows = more robust validation but shorter test periods.',
    jobWfTrainRatio: 'Train Ratio',
    jobWfTrainRatioDesc:
      'Fraction of data used for training. 0.75 = 75% train, 25% test. E.g. on 1 year: 9 months train + 3 months test per window. Range: 0.5 → 0.9.',
    jobWfEmbargo: 'Embargo (days)',
    jobWfEmbargoDesc:
      'Gap in days between train and test data to prevent lookahead bias via lagged indicators. 7 days = safe for daily timeframes. 1-2 days for intraday.',
    jobWfHoldout: 'Holdout (months)',
    jobWfHoldoutDesc:
      'Reserve N months at the end as independent final validation, never touched by optimizer. 2-3 months recommended. 0 = disabled.',
    jobWfMinTrades: 'Min Test Trades',
    jobWfMinTradesDesc:
      'Minimum trades per test window for statistical significance. <30 = unreliable. Window is flagged invalid if threshold not met.',
    jobWfMode: 'Mode',
    jobWfModeDesc:
      'rolling (default) = fixed-size sliding windows. anchored = train always starts from beginning (more data, less stationarity). cpcv = Combinatorial Purged CV, tests all possible data splits.',
    jobWfMultiSeed: 'Multi-Seed',
    jobWfMultiSeedDesc:
      'Run N extra hyperopts with different seeds on last window. If results diverge a lot, optimization surface is noisy → fragile results. 0 = disabled.',
    jobWfCpcvGroups: 'CPCV Groups',
    jobWfCpcvGroupsDesc:
      'Number of time-blocks for CPCV mode. C(N,K) combinations total. E.g. N=6, K=2 → C(6,2)=15 combinations. More groups = more combinations but shorter blocks.',
    jobWfCpcvTestGroups: 'CPCV Test Groups',
    jobWfCpcvTestGroupsDesc:
      'Test blocks held out per CPCV combination. K=2 with N=6 → 15 combinations and 5 backtest paths. Only used with mode=cpcv.',
    // Job actions & status
    jobStart: 'Start',
    jobAbort: 'Abort',
    jobConfirmAbort: 'Confirm Abort',
    jobShowLogs: 'Show Logs',
    jobHideLogs: 'Hide Logs',
    jobRunning: 'Running',
    jobHistory: 'Recent Jobs',
    jobTabConfig: 'Configuration',
    jobTabConsole: 'Console',
    jobConsoleEmpty: 'No job running. Start a job from the Configuration tab.',
    jobConsoleDuration: 'Duration',
    jobConsoleFinished: 'Finished',
    editorSave: 'Save',
    editorUseConfig: 'Use this config',
    editorEditConfig: 'Edit',
    editorEditStrategy: 'Edit',
    editorCustomConfig: 'Custom',
    editorModifiedWarning: 'Editing strategy source file directly',
    reconstitute_backtest: 'Re-run this backtest',
    reconstitute_hyperopt: 'Re-run this hyperopt',
    reconstitute_wfa: 'Re-run this walk-forward',
    reconstitute_hint: 'Opens the launcher with pre-filled parameters from this run',
    liveBacktest: 'Backtest this live period',
    liveBacktestHint: "Opens a backtest job pre-filled with this bot's config and date range",
    jobStatus_pending: 'Pending',
    jobStatus_running: 'Running',
    jobStatus_completed: 'Completed',
    jobStatus_failed: 'Failed',
    jobStatus_aborted: 'Aborted',

    // Detail tabs
    tabOverview: 'Overview',
    tabCharts: 'Charts',
    tabParameters: 'Parameters',
    tabConfig: 'Config',
    tabSourceCode: 'Source Code',
    tabCommand: 'Command',
    tabAnalytics: 'Analytics',
    tabAnalyse: 'Analysis',
    tabGraphiques: 'Charts',

    // Plot Profit & Plot Dataframe
    plotProfitTitle: 'Profit Plot',
    plotDataframeTitle: 'Pair Analysis',
    plotSelectPair: 'Select a pair',
    plotCombinedProfit: 'Combined Profit',
    plotProfitPerPair: 'Profit per Pair',
    plotParallelism: 'Trade Parallelism',
    plotUnderwaterAbs: 'Underwater (Absolute)',
    plotUnderwaterPct: 'Underwater (Relative %)',
    plotMaxDrawdown: 'Max Drawdown Zone',
    plotNoOhlcv: 'OHLCV data not available on disk',
    plotLoadingStrategy: 'Loading strategy indicators...',
    plotLoadingProfit: 'Computing profit plot...',
    plotLoadingDataframe: 'Loading pair data...',
    plotNoData: 'No data available',

    // Advanced Analytics
    aaLoadingAnalytics: 'Computing performance analytics for best epoch...',
    aaSectionTitle: 'Performance Analytics',
    aaBestEpochBanner: 'Best Epoch',
    navDiagnostic: 'Diagnostic',
    navEquity: 'Equity & Drawdowns',
    navPerformance: 'Performance',
    navTrades: 'Trades',
    navRisk: 'Risk',
    navConsistency: 'Consistency',
    navRobustness: 'Robustness',
    navParameters: 'Parameters',
    aaSectionEquityDrawdowns: 'Equity & Drawdowns',
    aaSectionReturns: 'Returns Analysis',
    aaSectionTradeAnalysis: 'Trade Analysis',
    aaSectionRisk: 'Risk Assessment',
    aaEquityCurve: 'Equity Curve',
    aaUnderwaterPlot: 'Underwater Plot',
    aaMonthlyReturns: 'Monthly Returns',
    aaRollingMetrics: 'Rolling Metrics',
    aaTradePnl: 'Trade PnL Distribution',
    aaRiskMetrics: 'Risk Metrics',
    aaDrawdownDetails: 'Drawdown Analysis',
    aaStreaks: 'Win/Loss Streaks',
    aaPairProfit: 'Pair Profit Distribution',
    hintEquityCurve:
      'Portfolio balance over time. Shows how the account value evolved throughout the backtest period. Steep drops indicate drawdowns.',
    eqStrategy: 'Strategy',
    eqBtcBenchmark: 'BTC Benchmark',
    hintUnderwater:
      'Continuous drawdown below the high-water mark. Shows the percentage decline from peak balance. The deeper the red, the more the strategy is underwater.',
    hintMonthlyReturns:
      'Calendar heatmap of monthly returns. Green = positive, red = negative. Helps identify seasonal patterns and consistency across months.',
    hintRollingMetrics:
      'Sharpe, Sortino and volatility computed on a rolling 30-day window. Reveals how risk-adjusted performance changes over time — a stable Sharpe is more trustworthy than a spiky one.',
    hintTradePnl:
      'Distribution of individual trade returns. A right-skewed distribution with a long positive tail is ideal. The red/green split shows the win/loss balance.',
    hintRiskMetrics:
      'Advanced risk metrics inspired by VectorBT Pro. VaR = worst expected daily loss at 95% confidence. CVaR = average loss beyond VaR. Omega = probability-weighted gain/loss ratio. Kelly = optimal bet fraction.',
    hintDrawdownDetails:
      'Top 5 deepest drawdowns with decline/recovery duration. Long recovery times indicate the strategy struggles to bounce back. Active drawdowns have no recovery yet.',
    hintStreaks:
      'Longest consecutive winning and losing streaks. Long loss streaks test risk management and psychological endurance. The distribution shows how often each streak length occurs.',

    // Risk metric descriptions
    descVar95: 'Worst expected daily loss at 95% confidence',
    descCvar95: 'Average loss in the worst 5% of days',
    descOmega: 'Ratio of gains to losses (>1 = profitable)',
    descTailRatio: 'Right tail vs left tail ratio (>1 = more upside)',
    descUlcer: 'Drawdown intensity (lower = less painful)',
    descRecovery: 'Net profit / max drawdown (>1 = recovered)',
    descGainPain: 'Total gains / total losses',
    descKelly: 'Optimal bet fraction of capital',

    // Tier 2
    aaDurationScatter: 'Duration vs Profit',
    aaExitReasons: 'Exit Reason Breakdown',
    aaWeekdayPattern: 'Day-of-Week Pattern',
    aaCumulativeTrades: 'Cumulative Returns',
    aaSectionTiming: 'Timing & Patterns',
    hintDurationScatter:
      'Each dot is a trade. X = hold time, Y = profit. Reveals if longer holds are more profitable or if quick exits dominate. Cluster patterns show strategy behavior.',
    hintExitReasons:
      'How trades exit and the average profit per exit type. A healthy strategy has diverse profitable exits — not just stoploss-heavy results.',
    hintWeekdayPattern:
      'Performance by day of week. Reveals if the strategy has weekday bias. Crypto markets trade 24/7 but liquidity patterns still create day-of-week effects.',
    hintCumulativeTrades:
      'Cumulative profit per trade. A smooth upward curve = consistent edge. Steep drops indicate clustered losses. Compare to equity curve (which is date-based).',

    // Tier 3
    aaRollingWinrate: 'Rolling Win Rate',
    aaRollingProfitFactor: 'Rolling Profit Factor',
    aaLongShort: 'Long vs Short',
    aaExposure: 'Position Exposure',
    exposureYAxis: 'Open Positions',
    aaExpectancy: 'Trade Expectancy',
    aaSectionRollingPerf: 'Rolling Performance',
    aaSectionStructure: 'Strategy Structure',
    hintRollingWinrate:
      'Win rate computed over a rolling 50-trade window. A stable line above 50% = consistent edge. Sharp drops signal regime changes or strategy degradation.',
    hintRollingProfitFactor:
      'Profit factor (gross wins / gross losses) on a rolling 50-trade window. Above 1.0 = profitable. Crossing below 1.0 = losing stretch. More stable = more robust.',
    hintLongShort:
      'Compares long and short trade performance. For directional strategies, one side often dominates. Large asymmetry may indicate the strategy only works in one direction.',
    hintExposure:
      'Number of simultaneously open positions over time. High spikes = capital concentration risk. Consistent exposure = predictable capital usage.',
    hintExpectancy:
      'Expected profit per trade with statistical confidence. SQN (System Quality Number) measures edge reliability. Kelly % suggests optimal position sizing.',

    // Mode toggle
    modeGlobal: 'Global Analysis',
    modeEpoch: 'Per Epoch',
    modeCompare: 'Compare Epochs',

    // Epoch selector
    epochSelectorLabel: 'Top 10 Epochs (by loss)',
    epochSelectPrompt: 'Select an epoch above to view its detailed analytics',

    // Compare mode
    compareLeft: 'Left epoch',
    compareRight: 'Right epoch',
    compareParams: 'Parameter Differences',
    compareMetric: 'Metric',
    compareParameter: 'Parameter',
    compareRankN: 'Rank {n}',

    // New charts
    aaReturnDistribution: 'Return Distribution Fit',
    aaDrawdownCalendar: 'Drawdown Calendar',
    aaMaeMfe: 'MAE / MFE Scatter',
    hintReturnDistribution:
      'Histogram of individual trade returns overlaid with a normal distribution fit. Deviations from normality (skew, fat tails) reveal hidden risk. Green bars = profitable trades, red = losses.',
    hintDrawdownCalendar:
      'Daily drawdown intensity displayed as a calendar heatmap. Darker cells = deeper drawdown on that day. Helps identify seasonal patterns and prolonged losing periods.',
    hintMaeMfe:
      'Maximum Adverse Excursion (MAE) and Maximum Favorable Excursion (MFE) vs final PnL. MAE shows worst intra-trade drawdown; MFE shows best unrealized gain. Helps optimize stop-loss and take-profit levels.',

    // Backtest analyse sections
    btNavSummary: 'Summary',
    btNavEquity: 'Equity & Drawdowns',
    btNavPerformance: 'Performance',
    btNavTrades: 'Trades',
    btNavRisk: 'Risk',
    btNavConsistency: 'Consistency',
    btNavPairs: 'Pairs',
    btNavConfig: 'Configuration',
    btScorecardTitle: 'Backtest Results',
    btScorecardDD: 'Max DD',
    btScorecardWinrate: 'Win Rate',

    // Backtest specific charts
    btHourlyPattern: 'Hourly Pattern',
    hintBtHourlyPattern:
      'Average profit and win rate by hour of day (0-23). Reveals intraday patterns — which hours generate the most alpha.',
    btCapitalUtilization: 'Capital Utilization',
    hintBtCapitalUtilization:
      'Percentage of available capital deployed over time. Low utilization means idle capital; very high utilization means the strategy may miss opportunities.',
    btPairHeatmap: 'Pair Performance Matrix',
    hintBtPairHeatmap:
      'Sortable table showing per-pair performance metrics. Color-coded cells highlight best and worst performers.',
    btBenchmark: 'Strategy vs Buy & Hold',
    hintBtBenchmark:
      'Equity curve comparison between the strategy and a simple buy-and-hold approach. Alpha = strategy excess return over benchmark.',

    // Backtest summary cards
    btBestPair: 'Best Pair',
    btWorstPair: 'Worst Pair',
    btTradesPerDay: 'Trades / Day',
    btMarketChange: 'Market Change',
    btWinLossDays: 'Win / Loss / Draw Days',
    btHoldingAvg: 'Avg Holding',
    btWinnerHolding: 'Winner Holding',
    btLoserHolding: 'Loser Holding',
    btExpectancy: 'Expectancy',
    btExpectancyRatio: 'Expectancy Ratio',
    btFinalBalance: 'Final Balance',

    // Backtest order stats
    btOrderStats: 'Order Statistics',
    btRejectedSignals: 'Rejected Signals',
    btTimedoutEntry: 'Timed Out Entries',
    btTimedoutExit: 'Timed Out Exits',
    btCanceledEntries: 'Canceled Entries',

    // Backtest config card
    btConfigGeneral: 'General',
    btConfigTimeframe: 'Timeframe',
    btConfigTimerange: 'Time Range',
    btConfigMaxOpenTrades: 'Max Open Trades',
    btConfigDays: 'Backtest Days',
    btConfigStart: 'Start Date',
    btConfigEnd: 'End Date',
    btConfigStoploss: 'Stoploss & Trailing',
    btConfigTrailing: 'Trailing Stop',
    btConfigTrailingPositive: 'Trailing Positive',
    btConfigTrailingOffset: 'Trailing Offset',
    btConfigRoi: 'ROI Table',
    btConfigRoiMinutes: 'Minutes',
    btConfigRoiReturn: 'Return',
    btConfigMarket: 'Market Context',

    // Day names
    dayMon: 'Mon',
    dayTue: 'Tue',
    dayWed: 'Wed',
    dayThu: 'Thu',
    dayFri: 'Fri',
    daySat: 'Sat',
    daySun: 'Sun',

    // Weekday pattern chart
    wdTotalProfit: 'Total Profit',
    wdWinRate: 'Win Rate',
    wdTrades: 'Trades',
    wdAvgProfit: 'Avg Profit',

    // Exit reason chart
    erCount: 'Count',
    erAvgProfit: 'Avg Profit %',
    erWinRate: 'Win Rate',
    erTotalProfit: 'Total Profit',

    // Convergence chart
    convEpochLoss: 'Epoch loss',
    convBestSoFar: 'Best so far',
    convEpoch: 'Epoch',
    convLoss: 'Loss',

    // Streaks
    skMaxWinStreak: 'Max Win Streak',
    skMaxLossStreak: 'Max Loss Streak',
    skWins: 'Wins',
    skLosses: 'Losses',
    skWinRate: 'Win Rate',
    skWinStreakDist: 'Win Streak Distribution',
    skLossStreakDist: 'Loss Streak Distribution',
    skBarTooltip: '{count} occurrence(s) of {length} consecutive {type}',
    skBarWinType: 'wins',
    skBarLossType: 'losses',
    skWinStreakDistDesc:
      'How many times each winning streak length occurred. A streak of 3 means 3 consecutive winning trades.',
    skLossStreakDistDesc:
      'How many times each losing streak length occurred. Long streaks indicate potential regime sensitivity.',
    skAxisStreakLength: 'Streak length',
    skAxisOccurrences: 'Occurrences',

    epochSectionEquity: 'Equity & Drawdowns',
    epochSectionPerformance: 'Performance',
    epochSectionTrades: 'Trades',
    epochSectionRisk: 'Risk & Structure',
    epochSectionConsistency: 'Consistency',

    // Detail header
    deleteRun: 'Delete run',
    deleteConfirm: 'Are you sure you want to delete this run?',
    favorite: 'Favorite',
    notes: 'Notes',
    verdictGood: 'Good',
    verdictCaution: 'Caution',
    verdictDanger: 'Danger',
    summaryTitle: 'Analysis Summary',
    validationChecklist: 'Validation Checklist',
    copyCommand: 'Copy command',
    commandCopied: 'Command copied to clipboard',
    noMetadata: 'No metadata available (legacy run)',

    // Timestamps
    started: 'Started',
    ended: 'Ended',
    duration: 'Duration',

    // Metrics
    totalProfit: 'Total Profit',
    totalTrades: 'Total Trades',
    bestSharpe: 'Best Sharpe',
    bestLoss: 'Best Loss',
    hintTotalProfit: 'Total profit of the best epoch as a percentage of starting capital.',
    hintTotalTrades: 'Total number of trades executed during the best epoch.',
    hintBestSharpe: 'Sharpe ratio of the best epoch. Above 1.0 is good, above 2.0 is excellent.',
    hintBestLoss: 'Loss function value of the best epoch. Lower (more negative) is better.',
    bestEpochResults: 'Best epoch results:',
    epochsCompleted: 'Epochs',
    verdictGrade: 'Grade',
    nWindows: 'Windows',

    // Config / Source
    configSaved: 'Saved Config',
    configCurrent: 'Current Config',
    configChanged: 'Config has changed since this run',
    sourceSaved: 'Saved Strategy Source',
    sourceCurrent: 'Current Strategy Source',
    sourceChanged: 'Strategy has been modified since this run',
    fileDeleted: 'File no longer exists',
    noDiff: 'No changes detected',
    showDiff: 'Show diff',

    // WFA
    trainRange: 'Train Range',
    testRange: 'Test Range',
    trainProfit: 'Train Profit',
    testProfit: 'Test Profit',
    degradation: 'Degradation',
    windowsTitle: 'Walk-Forward Windows',
    oosTradesLabel: 'OOS Trades',
    noParamsAvailable: 'No parameters available for this run.',

    // Bot offline
    botOfflineTitle: 'Bot is offline',
    botOfflineDesc:
      'The main bot needs to be running to display backtests, hyperopts, and walk-forward results. Start the bot and this page will load automatically.',

    // Auth errors
    authRequired: 'Authentication Required',
    authRequiredDesc:
      'You need to log in to access Strategy Development. This page shows your strategy source code, configs, and optimization results — it is protected by your bot password.',
    authStep1Title: '1. Configure API credentials',
    authStep1Desc:
      'Make sure your bot config file has an api_server section with a username and password:',
    authStep2Title: '2. Log in via FreqUI',
    authStep2Desc:
      'Go to Settings (gear icon) and add your bot with the URL, username, and password you configured. FreqUI will obtain a JWT token automatically when you log in.',
    authStep3Title: '3. Come back here',
    authStep3Desc:
      'Once logged in, return to this page. Your runs will load automatically. If you see this message again, your session may have expired — just log in again.',
    modeNotSupported: 'Feature Not Available',
    modeNotSupportedDesc:
      'The Strategy Development endpoints are not available on this bot. Make sure you are running a version of Freqtrade that includes the stratdev API module.',
    endpointNotFound: 'Endpoint Not Found',
    endpointNotFoundDesc:
      'The /stratdev API endpoints were not found on this bot. This usually means the bot is running an older version of Freqtrade that does not include Strategy Development. Update your Freqtrade installation and restart the bot.',
    connectionError: 'Connection Failed',
    connectionErrorDesc:
      'Could not connect to the bot API. Check that the bot is running and that FreqUI is configured with the correct URL.',
    errorDetail: 'Error {code}: {message}',
    retry: 'Retry',

    // No snapshot fallbacks
    noSnapshotWarningTitle: 'Snapshot not available',
    noSnapshotSourceDesc:
      'The exact strategy source used during this run was not saved. Showing the current version of the strategy file instead.',
    noSnapshotConfigDesc:
      'The exact config used during this run was not saved. Showing the current bot configuration instead.',
    noSnapshotCommandDesc:
      'The exact command used was not saved. This is an approximation reconstructed from the available metadata.',
    noSourceAvailable: 'No strategy source available for this run.',
    noConfigAvailable: 'No config available for this run.',
    noCommandAvailable: 'No command available for this run type.',
    commandSaved: 'Saved Command',
    commandInferred: 'Inferred Command',

    // Actions
    copyJson: 'Copy JSON',
    copyAll: 'Copy all',
    copied: 'Copied!',
    expand: 'Expand',
    collapse: 'Collapse',

    // Chart sections
    sectionOverfitWarnings: 'Overfit Warnings',
    sectionHealthChecks: 'Health Checks',
    sectionProfitRobustness: 'Profit Robustness',
    sectionMonteCarlo: 'Monte Carlo Simulation',
    sectionConvergenceDistribution: 'Convergence & Distribution',
    sectionParameterAnalysis: 'Parameter Analysis',
    sectionParameterSensitivity: 'Parameter Sensitivity',
    sectionWindowPerformance: 'Window Performance',
    sectionRobustnessAnalysis: 'Robustness Analysis',
    sectionWarnings: 'Warnings',

    // No negative trades warning
    noLosingTradesTitle: 'No losing trades detected',
    noLosingTradesDesc:
      'This is extremely unusual and almost certainly indicates overfitting. A real trading strategy will always have losing trades. The optimizer may have found parameters that perfectly fit historical noise rather than a genuine edge. Treat these results with extreme caution.',
    noLosingTradesAction1: 'Increase --hyperopt-min-trades to require more trades',
    noLosingTradesAction2: 'Widen the timerange to include different market conditions',
    noLosingTradesAction3: 'Use walk-forward validation to check out-of-sample performance',
    noLosingTradesAction4: 'Consider switching to CalmarHyperOptLoss which penalizes drawdown',

    // Chart titles
    chartLossConvergence: 'Loss Convergence',
    chartLossDistribution: 'Loss Distribution',
    chartReturnVsDrawdown: 'Return vs Drawdown',
    chartPairProfitDistribution: 'Pair Profit Distribution',
    chartParallelCoords: 'Parallel Coordinates (Top 10)',
    chartParameterCorrelation: 'Parameter Correlation',
    chartMonteCarloTitle: 'Monte Carlo — Trade Order Robustness',
    hintConvergence:
      'Each dot is one epoch. The green line tracks the best loss so far. A flat line at the end = converged. Still dropping = try more epochs.',
    hintLossHistogram:
      'Distribution of all epoch losses. Green = top 25%, yellow = middle, red = bottom 25%. Your best loss should be deep in the green zone.',
    hintReturnVsDd:
      "Each dot is one epoch's profit vs drawdown trade-off. Green zone = profit > 0 and DD < 25%. More dots there = robust parameter space.",
    hintMonteCarlo:
      'Shuffles trade order many times to test if your edge is sequence-dependent. P5 positive = profitable in 95% of orderings (robust).',
    hintPairProfit:
      'Profit contribution per pair from the best epoch. A good strategy profits from multiple pairs, not just one.',
    hintParallelCoords:
      'Each line is an epoch. Green = low loss, red = high loss. Where green lines cluster on an axis = sweet spot for that parameter.',
    hintCorrelation:
      'Parameter correlations across top results. Gray (near 0) = independent (ideal). Strong red/blue = parameters may be redundant or coupled.',
    hintSensitivity:
      "Loss heatmap for two parameters. Flat color = parameters don't interact (robust). Strong gradient = narrow optimal region.",
    hintBvm:
      'Compares best epoch profit to median of top-10. ≤ 1.5x = consistent. > 2x = best epoch is likely an outlier.',
    hintPrt:
      'Best = value from the best epoch. Recommended = median of top-5 (more robust). Narrow top-10 range = optimizer agrees.',
    hintDispersion:
      'Spread of key metrics across top-10 epochs. Narrow band = all top results agree (robust). Wide band = best epoch may be an outlier.',
    hintWfe:
      'Walk-Forward Efficiency per window. > 50% = out-of-sample retains most of in-sample edge. < 30% = likely overfit.',
    hintTrainVsTest:
      'Compares in-sample (train) vs out-of-sample (test) profit per window. Consistent ratio = robust. Large gaps = overfitting.',
    hintMarketContext:
      'Market regime per window (bull/bear/sideways). Helps explain performance variation — poor results in one regime may be acceptable.',
    chartExportPng: 'Export as PNG',
    chartFullscreen: 'Fullscreen',
    chartWfe: 'Walk-Forward Efficiency',
    chartTrainVsTest: 'Train vs Test Profit',
    chartMarketContext: 'Market Context per Window',
    wfaWfeTitle: 'Walk-Forward Efficiency',
    wfaTrainVsTestTitle: 'Train vs Test Profit',
    wfaMarketContextTitle: 'Market Context per Window',

    // Monte Carlo
    mcProbPositive: 'P(profit > 0)',
    mcRobust: 'Robust',
    mcMarginal: 'Marginal',
    mcNoEdge: 'No edge',
    mcSimulations: '{n} simulations',
    mcTrades: '{n} trades',
    mcMedian: 'Median (P50)',
    mcMean: 'Mean',
    mcIqr: 'IQR (P25-P75)',
    mcWhiskers: 'Whiskers (P5-P95)',
    mcClampWarning: 'Chart axis capped at ±2000% for readability. Labels show actual values.',
    mcHowToReadTitle: 'How to read this chart',
    mcWhatItDoes: 'What it does',
    mcWhatItDoesDesc:
      "Shuffles the order of your {trades} trades {sims} times and computes the final compounded profit each time. This tests whether your strategy's edge depends on a lucky sequence of trades or is genuinely robust.",
    mcHowToReadBoxPlot: 'How to read the box plot',
    mcBoxDesc:
      'The middle 50% of outcomes. A narrow box means consistent results regardless of trade order.',
    mcMedianDesc:
      'Half of all simulations ended above this value, half below. This is your "typical" outcome.',
    mcMeanDesc:
      'The average across all simulations. If much higher than median, a few lucky orderings pull it up (right-skewed).',
    mcWhiskersDesc: 'The range covering 90% of outcomes. P5 is your worst realistic case.',
    mcKeyInsight: 'Key insight: P5 is what matters most',
    mcKeyInsightDesc:
      'If P5 is positive, your strategy is profitable in 95% of trade orderings — the edge is order-robust. If P5 is negative but P50 is positive, you have an edge but it depends on favorable sequencing.',
    mcThresholdTitle: 'P(profit > 0) interpretation',
    mcThresholdRobust:
      '≥ 80% — Robust edge. Your strategy is profitable in the vast majority of trade orderings. The edge is real and not dependent on luck.',
    mcThresholdMarginal:
      '60% - 80% — Marginal. There is likely an edge, but it is sensitive to trade ordering. Consider whether the strategy has enough trades or whether the edge could be overfitted.',
    mcThresholdNoEdge:
      "< 60% — No reliable edge. The strategy's profitability is largely dependent on the order in which trades occur. Treat any backtest profit as noise.",

    // Loss Histogram
    lhBestLoss: 'Best loss: {value} — beats {pct}% of epochs',
    lhSubtitle: 'Your best loss ({loss}) outperforms {pct}% of all epochs',
    lhExceptional: 'Exceptional — top {pct}%',
    lhDecent: 'Decent — but many similar results',
    lhStruggled: 'Optimizer struggled',
    lhHowToRead: 'How to read',
    lhDesc1: 'Each bar shows how many epochs fell in that loss range',
    lhDesc2Green: 'Green zone',
    lhDesc2Text: ' = top 25% of results, ',
    lhDesc2Yellow: 'Yellow',
    lhDesc2Mid: ' = middle 50%, ',
    lhDesc2Red: 'Red',
    lhDesc2End: ' = bottom 25%',
    lhDesc3: 'Your best loss (cyan dashed line) should be deep in the green zone',
    lhDesc4:
      'If best percentile ≥ 90%: exceptional. 50–90%: decent but many similar. < 50%: optimizer struggled',
    lhInsightConcentrated:
      '{pct}% of epochs are in the best quartile — the optimizer converges well toward good solutions',
    lhInsightSparse:
      'Very few epochs in the best zone — possible overfitting. The best result may be a lucky outlier',
    lhInsightOverfit:
      'Only 1–2 epochs near the best loss among 50+ total — high overfitting risk. This result is likely an anomaly',
    lhInsightExcellent:
      'Excellent distribution: the best loss is in the top 5% AND many epochs are nearby — robust optimization',
    lhInsightPeakLow:
      'Peak concentration is in the low-loss zone — the optimizer naturally gravitates toward good solutions',
    lhInsightPeakHigh:
      'Most epochs are in the high-loss zone — the search space may be too large or the strategy is fragile',

    // Duration Analysis
    durAll: 'All',
    durWinners: 'Winners',
    durLosers: 'Losers',
    durMinutes: 'Duration',
    durSummary: 'Summary',
    durByExitReason: 'By Exit Reason',
    durTrades: 'Trades',
    durAvgProfit: 'Avg Profit',
    durTotalProfit: 'Total Profit',
    durWinrate: 'Win Rate',
    durAvgStake: 'Avg Stake',
    durBestBucket: 'Best duration window: {label} (avg {profit}%)',
    durWorstBucket: 'Worst duration: {label} (avg {profit}%) — consider a time-based forced exit',
    durLongNegShortPos:
      'Short holds are profitable but long holds lose money — exits should be faster',
    durAllPairs: 'All pairs',
    durDangerZone: '{count} trades ({pct}%) in the danger zone: long duration + large loss',
    aaDurationBoxplot: 'Duration Distribution',
    aaDurationBuckets: 'Performance by Duration',
    aaStuckTrades: 'Stuck Trade Analysis',
    aaDurationProfitHeatmap: 'Duration × Profit',
    hintDurationBoxplot:
      'Box plots of hold times for winners vs losers. Outliers (dots) are positions held much longer than typical.',
    hintDurationBuckets:
      'Groups trades by holding time. If long-duration buckets lose money, consider a time-based forced exit.',
    hintStuckTrades: 'Trades held >2x median duration. Shows capital blocked and worst offenders.',
    hintDurationProfitHeatmap:
      'Cross-tabulates duration vs profit. Ideally, most trades cluster in short-duration + positive-profit.',
    stuckCount: 'Stuck trades',
    stuckPctTrades: '% of trades',
    stuckAvgProfit: 'Avg profit',
    stuckCapitalBlocked: 'Capital blocked',
    stuckThreshold: 'Threshold',
    stuckMedian: 'Median duration',
    stuckOppCost: 'Opportunity cost',
    stuckFundingCost: 'Funding cost (est.)',
    stuckPair: 'Pair',
    stuckDuration: 'Duration',
    stuckProfit: 'Profit',
    stuckStake: 'Stake',
    stuckExit: 'Exit',
    stuckOrders: 'Orders',

    // Shared metric labels
    metricSharpe: 'Sharpe',
    metricSortino: 'Sortino',
    metricCalmar: 'Calmar',
    metricMaxDD: 'Max DD',
    metricProfitFactor: 'Profit Factor',
    metricWinRate: 'Win Rate',
    metricTrades: 'Trades',
    metricTotalTrades: 'Total Trades',
    metricTotalProfit: 'Total Profit',
    metricProfit: 'Profit',
    metricProfitPct: 'Profit %',
    metricProfitAbs: 'Profit (abs)',
    metricAvgProfit: 'Avg Profit',
    metricAvgDuration: 'Avg Duration',
    metricLoss: 'Loss',
    metricBestLoss: 'Best Loss',
    metricGrade: 'Grade',
    metricEpochs: 'Epochs',
    metricPF: 'PF',
    metricSQN: 'SQN',
    metricCAGR: 'CAGR',
    metricExpectancy: 'Expectancy',
    metricAvgWin: 'Avg Win',
    metricAvgLoss: 'Avg Loss',
    metricPayoffRatio: 'Payoff Ratio',
    metricKelly: 'Kelly %',
    metricHalfKelly: 'Half Kelly %',
    metricCI95: 'CI 95%',
    metricMean: 'Mean',
    metricMedian: 'Median',
    metricStdDev: 'Std Dev',
    metricBestTrade: 'Best Trade',
    metricWorstTrade: 'Worst Trade',
    metricVaR95: 'VaR 95%',
    metricCVaR95: 'CVaR 95%',
    metricOmega: 'Omega',
    metricTailRatio: 'Tail Ratio',
    metricUlcerIndex: 'Ulcer Index',
    metricRecoveryFactor: 'Recovery Factor',
    metricGainPain: 'Gain/Pain',
    metricTradesPerDay: 'Trades/Day',
    metricDays: 'Days',
    metricTimeframe: 'Timeframe',
    metricFinalBalance: 'Final Balance',
    metricDrawdown: 'Drawdown',
    metricDSR: 'DSR',
    metricOOSTrades: 'OOS Trades',
    metricOOSSQN: 'OOS SQN',
    metricOOSExpectancy: 'OOS Expectancy',
    metricOOSProfit: 'OOS Profit',
    metricKRatio: 'K-Ratio',
    metricCarverDiscount: 'Carver Discount',

    // Chart series / axis
    seriesStrategy: 'Strategy',
    seriesBuyHold: 'Buy & Hold',
    seriesCumulativePct: 'Cumulative %',
    seriesBalance: 'Balance',
    seriesTradePnL: 'Trade P&L',
    seriesTrain: 'Train',
    seriesTest: 'Test',
    seriesWinners: 'Winners',
    seriesLosers: 'Losers',
    seriesActual: 'Actual',
    seriesNormalFit: 'Normal fit',
    axisDuration: 'Duration (min)',
    axisProfit: 'Profit %',
    axisWindow: 'Window',
    axisWFE: 'WFE',
    axisRatio: 'Ratio',
    axisVolatility: 'Volatility',
    axisPath: 'Path',
    axisReturnPct: 'Return %',
    seriesBTCChange: 'BTC Change',
    seriesVolatility: 'Volatility',
    seriesTradeEntry: 'Trade Entry',
    seriesTradeExit: 'Trade Exit',
    seriesVolume: 'Volume',
    seriesRollingSharpe: 'Rolling Sharpe ({window}d)',
    seriesRollingSortino: 'Rolling Sortino ({window}d)',
    seriesRollingVolatility: 'Rolling Volatility ({window}d)',
    chartCPCVPathReturns: 'CPCV Path Returns',
    signalEntryLong: 'Entry Long',
    signalExitLong: 'Exit Long',
    signalEntryShort: 'Entry Short',
    signalExitShort: 'Exit Short',
    metricEpochNum: 'Epoch #{n}',
    metricRank: 'Rank',

    // Table columns
    columnPair: 'Pair',
    columnRank: '#',
    columnDepth: 'Depth',
    columnStart: 'Start',
    columnValley: 'Valley',
    columnEnd: 'End',
    columnDecline: 'Decline',
    columnRecovery: 'Recovery',
    columnTotal: 'Total',
    columnPeriod: 'Period',

    // UI labels
    statusActive: 'Active',
    copied: 'Copied!',
    copy: 'Copy',
    viewTree: 'Tree',
    viewRaw: 'Raw',
    formatJSON: 'JSON',
    formatTable: 'Table',
    noWarnings: 'No warnings',
    sortDate: 'Date',
    sortProfit: 'Profit',
    sortLoss: 'Loss',
    sortGrade: 'Grade',
    favoritesOnly: 'Favorites only',
    favorites: 'Favorites',
    collapseSidebar: 'Collapse sidebar',
    expandSidebar: 'Expand sidebar (Ctrl+K)',
    sortBy: 'Sort by {metric}',
    exportParams: 'Export params JSON',
    sqnSuperb: 'Superb',
    sqnExcellent: 'Excellent',
    sqnGood: 'Good',
    sqnAverage: 'Average',
    sqnBelowAvg: 'Below avg',
    sqnPoor: 'Poor',

    // Inter-Pair Correlation
    aaPairCorrelation: 'Pair Correlation Matrix',
    aaConcentrationRisk: 'Concentration Risk',
    aaMaxSimultaneousLoss: 'Max Simultaneous Loss',
    hintPairCorrelation:
      'Correlation between daily P&L of each pair. High correlation means pairs move together — diversification benefit is limited.',
    hintConcentrationRisk:
      'Measures how concentrated your profits are across pairs. HHI index quantifies diversification (lower = more diversified).',
    hintMaxSimultaneousLoss:
      'Worst-case scenario: the maximum loss happening across multiple positions at the same time.',
    corrHighlyCorrelated: 'Highly Correlated Pairs',
    corrAvgCorrelation: 'Avg Correlation',
    corrHhi: 'HHI Index',
    corrTopPair: 'Top Pair',
    corrHighPairs: 'High Corr. Pairs',
    corrDiversified: 'Diversified',
    corrModerate: 'Moderate',
    corrConcentrated: 'Concentrated',
    corrVolumeShare: 'Volume Share',
    corrMaxLoss: 'Max Loss',
    corrLossDate: 'Date',
    corrLossCount: 'Positions',
    corrLossPairs: 'Pairs',
    concHhi: 'HHI Index',
    concTopPair: 'Top Pair',
    concAvgCorr: 'Avg Correlation',
    concHighCorrCount: 'High Corr. Pairs',
    concVolumeDistribution: 'Volume Distribution',
    mslMaxLoss: 'Max Loss',
    mslPositions: 'Positions',
    mslDate: 'Date',
    mslPairsInvolved: 'Pairs Involved',

    // DCA Entry Analysis
    aaDcaDistribution: 'DCA Level Distribution',
    aaDcaProfitContribution: 'DCA Profit Contribution',
    aaDcaRecovery: 'DCA Recovery Analysis',
    hintDcaDistribution:
      'How many trades reach each DCA level (Base, SO1, SO2...). Colored by win rate. A healthy DCA strategy has most trades closing at base or SO1.',
    hintDcaProfitContribution:
      'Compares profit from single-entry trades vs multi-entry DCA trades. Shows whether DCA actually improves results.',
    hintDcaRecovery:
      'Recovery rate of DCA trades — what percentage of trades that needed safety orders ended profitable.',
    dcaNoDca: 'No DCA detected — all trades used a single entry',
    dcaAvgEntries: 'Avg Entries',
    dcaRecoveryRate: 'Recovery Rate',
    dcaDcaTrades: 'DCA Trades',
    dcaSingleAvg: 'Single Entry Avg',
    dcaMultiAvg: 'Multi Entry Avg',
    dcaSingleEntry: 'Single entry',
    dcaMultiEntry: 'Multi entry (DCA)',
    dcaProfitContrib: 'Profit Contribution',
    dcaAvgProfit: 'Avg Profit',
    dcaPair: 'Pair',
    dcaAvgEntriesCol: 'Avg Entries',
    dcaTrades: 'Trades',
    dcaHighRecovery: 'DCA recovery is effective (>{pct}%)',
    dcaLowRecovery: 'Low DCA recovery — safety orders not helping',
    dcaImprovesProfit: 'DCA improves average profit',
    dcaDegradesProfit: 'DCA degrades average profit',
    dcaDeepLosing: 'Deep DCA levels (6+) are mostly losing',
    dcaCount: 'Count',
    dcaWinRate: 'Win Rate',
    dcaAvgDuration: 'Avg Duration',
    dcaAvgStake: 'Avg Stake',
    dcaTradeCount: 'Trade Count',
    dcaSingleEntryAvg: 'Single Entry Avg',
    dcaMultiEntryAvg: 'Multi Entry Avg',

    // Market Regime Analysis
    aaRegimePerformance: 'Regime Performance',
    aaRegimeTimeline: 'Regime Timeline',
    aaRegimeTransitions: 'Regime Transitions',
    hintRegimePerformance:
      'Strategy performance broken down by market regime. Reveals if the strategy is "all-weather" or dependent on specific conditions.',
    hintRegimeTimeline:
      'Timeline showing which regime was active at each point. Background colors indicate the detected regime, line shows volatility.',
    hintRegimeTransitions:
      'Probability of transitioning from one regime to another. Helps anticipate upcoming market conditions.',
    regimeBullQuiet: 'Bull Quiet',
    regimeBullVolatile: 'Bull Volatile',
    regimeBearQuiet: 'Bear Quiet',
    regimeBearVolatile: 'Bear Volatile',
    regimeDailyView: 'Daily P&L',
    regimeTradeView: 'Per Trade',
    regimeAvgProfit: 'Avg Profit',
    regimeWinrate: 'Win Rate',
    regimeDays: 'Days',
    regimePctTime: '% of Time',
    regimeTransitionMatrix: 'Transition Probabilities',
    regimeDependent: 'Strategy performance is regime-dependent',
    regimeVulnerableBear: 'Vulnerable in bear volatile conditions',
    regimeAllWeather: 'All-weather strategy — profitable in all regimes',
    regimeVolatility: 'Volatility',
    regimeTrend: 'Trend',
    regimeAvgDailyProfit: 'Avg Daily Profit',
    regimeTotalProfit: 'Total Profit',
    regimeTrades: 'Trades',
    regimeFromTo: 'From \\ To',
    regimeTimeInEach: 'Time in each regime',
    regimeInsights: 'Insights',
    regimeEquity: 'Equity',
    regimeShowOverlay: 'Regimes',
    regimeTimeline: 'Regime Timeline',

    // Dispersion Bands
    dispersionTitle: 'Top-10 Dispersion',
    dispersionProfit: 'Profit',
    dispersionDrawdown: 'Drawdown',
    dispersionSharpe: 'Sharpe',
    dispersionNarrow: 'narrow',
    dispersionModerate: 'moderate',
    dispersionWide: 'wide',
    dispersionConsistent: 'Consistent — top-10 results are tightly clustered. Robust optimization.',
    dispersionModerateAdvisory:
      'Moderate spread — your results vary depending on which epoch you pick',
    dispersionHighVariance:
      'High variance — results are highly sensitive to epoch selection. Consider trusting the median over the best.',
    dispersionHowToRead:
      'Shows the spread of key metrics across your top-10 epochs. A narrow band means all top results agree (robust). A wide band means the "best" epoch may be an outlier — the median is more trustworthy.',

    // Pair Profit
    pairProfitPairsWithTrades: '{traded}/{total} pairs with trades',
    pairProfitShowAll: 'Show all pairs',
    pairProfitSingleInstrument:
      'Strategy only works on a single instrument ({pair}). Very fragile.',
    pairProfitConcentration: 'High pair concentration: {pair} accounts for {pct}% of total profit.',
    pairProfitHowToReadTitle: 'How to read this chart',
    pairProfitDesc1: 'Shows profit contribution per trading pair from the best epoch',
    pairProfitDesc2: 'Green = positive profit, Red = negative profit',
    pairProfitDesc3: 'Number in parentheses = trade count for that pair',
    pairProfitDesc4: 'A good strategy profits from multiple pairs, not just one',

    // Parallel Coordinates
    pcBestEpoch: 'Best epoch (loss: {loss}):',
    pcBestLowLoss: 'Best (low loss)',
    pcWorstHighLoss: 'Worst (high loss)',
    pcHowToReadTitle: 'How to read this chart',
    pcDesc1: 'Each vertical axis = one parameter (bottom = minimum, top = maximum)',
    pcDesc2: "Each line = one epoch's parameter combination",
    pcDesc3: 'Green lines = low loss (good), Red lines = high loss (bad)',
    pcDesc4: 'Where green lines cluster = sweet spot for that parameter',
    pcDesc5: 'If green and red lines overlap on an axis, that parameter has little impact',
    pcQualityMap: 'Parameter Quality Map',
    pcQualityGood: 'Good (low loss)',
    pcQualityMedium: 'Medium',
    pcQualityBad: 'Bad (high loss)',
    pcQualityNoData: 'No data',
    pcQualityBest: 'Best epoch',
    pcQualityMedian: 'Median',

    // Correlation Heatmap
    corrRedundant: 'Some parameters have |r| > 0.7 — consider merging or removing redundant params',
    corrIndependent: 'All correlations < 0.3 — each parameter contributes independently',
    corrModerate: 'Max |r| = {val} — moderate correlations, generally acceptable',
    corrCoeff: 'Correlation',
    corrStrength: 'Strength',
    corrWeak: 'Weak',
    corrMod: 'Moderate',
    corrStrong: 'Strong',
    corrHowToReadTitle: 'How to read this chart',
    corrDesc: 'Shows how parameters relate to each other across top optimization results.',
    corrGray: 'Gray (near 0)',
    corrGrayDesc: ' = ideal — parameters are independent.',
    corrBlue: 'Blue (negative, |r| > 0.7)',
    corrBlueDesc: ' = inverse relationship — when one goes up, the other goes down.',
    corrRed: 'Red (positive, |r| > 0.7)',
    corrRedDesc: ' = move together — potentially redundant.',

    // Sensitivity Grid
    sensWeakInteraction: 'Weak interaction — loss is stable across combinations (robust)',
    sensStrongInteraction: 'Strong interaction — optimal region may be narrow, tune these together',
    sensModerateInteraction: 'Moderate interaction (CV = {cv}%)',
    sensNotEnoughData: 'Not enough data points to assess interaction strength',
    sensHowToReadTitle: 'How to read this chart',
    sensDesc1: 'Shows how the loss changes when two parameters vary simultaneously.',
    sensGreen: 'Green cells',
    sensGreenDesc: ' = low loss (good parameter combinations).',
    sensRed: 'Red cells',
    sensRedDesc: ' = high loss (bad parameter combinations).',
    sensFlat: 'Flat color throughout',
    sensFlatDesc: " = parameters don't interact (robust).",
    sensGradient: 'Strong pattern/gradient',
    sensGradientDesc: ' = parameters interact strongly — optimal region may be narrow.',
    sensPattern: 'Strong pattern/gradient',
    sensPatternDesc: ' = parameters interact strongly — optimal region may be narrow.',
    sensEmpty: 'Empty cells',
    sensEmptyDesc: ' = no epoch tested that combination.',

    // Convergence
    convConverged: 'Loss plateau reached — the optimizer has converged.',
    convNotConverged: 'Still improving in the last 30%. Consider running more epochs.',
    convHowToReadTitle: 'How to read this chart',
    convDesc1: "Each gray dot = one epoch's loss value, plotted in chronological order",
    convDesc2: 'The green line tracks the best loss seen so far — it can only go down',
    convDesc3: 'A flat green line at the end = the optimizer has converged (good)',
    convDesc4: 'If the green line is still dropping at the end, you may benefit from more epochs',
    convDesc5: 'The cyan diamond marks the best epoch overall',

    // Return vs DD
    rvddIdealZone: '{count}/{total} epochs in ideal zone (profit > 0, DD < 25%)',
    rvddBest: 'Best: {profit}% profit, {dd}% DD',
    rvddHowToReadTitle: 'How to read this chart',
    rvddDesc1: "Each dot = one epoch's trade-off between profit and drawdown",
    rvddDesc2: 'Green-shaded zone = ideal region (profit > 0, DD < 25%)',
    rvddDesc3: 'Cyan dot = best epoch (lowest loss)',
    rvddDesc4: 'Many dots in the green zone = robust parameter space',
    rvddDesc5: 'Few dots in the green zone = narrow viable region, higher overfitting risk',

    // Best vs Median
    bvmTitle: 'Best vs. Median Top-10',
    bvmBestEpoch: 'Best Epoch',
    bvmMedianTop10: 'Median Top-10',
    bvmGapRatio: 'Gap Ratio',
    bvmConsistent: 'Consistent',
    bvmModerateGap: 'Moderate gap',
    bvmOutlier: 'Outlier — luck not skill',
    bvmHowToRead: 'How to read',
    bvmDesc1: "Compares your best epoch's profit to the median of the top-10 epochs.",
    bvmDesc2: '≤ 1.5x = consistent — the best is close to the group (green).',
    bvmDesc3: '1.5x - 2x = moderate gap — some epoch dependence (yellow).',
    bvmDesc4:
      '> 2x = outlier — the best epoch is a statistical fluke. Trust the median instead (red).',

    // DSR Analysis Card
    dsrTitle: 'Deflated Sharpe Ratio',
    dsrObservedSharpe: 'Observed Sharpe',
    dsrExpectedMaxSR: 'E[max SR]',
    dsrExpectedMax: 'E[max SR]',
    dsrNTrials: 'N Trials',
    dsrGenuine: 'Genuine',
    dsrOverfitted: 'Overfitted',
    hintDsr:
      'Deflated Sharpe Ratio (DSR) tests whether the observed Sharpe ratio is statistically significant given the number of trials. If DSR says "Overfitted", the Sharpe may be due to luck from running many optimizations.',

    // DOF Analysis Card
    dofTitle: 'Degrees of Freedom',
    dofCritical: 'Critical (5)',
    dofExcellent: 'Excellent (30+)',
    dofTradesLabel: 'trades',
    dofParamsLabel: 'params',
    dofTradesParams: '{trades} trades / {params} params',
    hintDof:
      'Degrees of Freedom measures the ratio of trades to optimized parameters. More trades per parameter = more reliable optimization. Below 10:1 is concerning, above 20:1 is excellent.',

    // Distribution Analysis Card
    distTitle: 'Return Distribution',
    distSkewness: 'Skewness',
    distHeavyLeftTail: 'Heavy left tail',
    distKurtosis: 'Excess Kurtosis',
    distFatTails: 'Fat tails',
    distTrades: 'Trades',

    // Sans Top Trade Card
    sttTitle: 'Profit Concentration',
    sttTotalProfit: 'Total Profit',
    sttAllTrades: 'All Trades',
    sttWithoutTop1: 'Without Top 1',
    sttWithoutTop2: 'Without Top 2',
    sttFragile: 'Fragile',
    sttDiversified: 'Diversified',

    // Regime Analysis Card
    raTitle: 'Regime Analysis',
    raTrades: 'Trades',
    raProfit: 'Profit',
    raWinRate: 'Win Rate',
    raAvgProfit: 'Avg Profit',
    raConsistent: 'Consistent',
    raInconsistent: 'Inconsistent',
    raFirstHalf: 'First half',
    raSecondHalf: 'Second half',

    // Benchmark Card
    bmTitle: 'Benchmark Comparison',
    bmSharpe: 'Sharpe',
    bmMaxDD: 'Max DD',
    bmAbove: 'above',
    bmBelow: 'below',
    bmHealthy: 'healthy',
    bmHigh: 'high',

    // Code Viewer
    cvLines: '{n} lines',
    cvCopied: 'Copied',
    cvCopy: 'Copy',
    cvSearch: 'Search (Ctrl+F)',
    cvSearchPlaceholder: 'Search in code...',
    cvNoResults: 'No results',
    cvFontSmaller: 'Decrease font size',
    cvFontLarger: 'Increase font size',
    cvFoldAll: 'Fold all',
    cvUnfoldAll: 'Unfold all',
    cvFoldedLines: 'lines hidden',

    // Param Panel
    ppBestEpochTag: 'Best Epoch',
    ppConsensusTag: 'Consensus',
    ppSnapshotTag: 'Snapshot',
    ppSpace: 'Space',
    ppParameter: 'Parameter',
    ppValue: 'Value',
    ppTop5Median: 'Top-5 Median',
    ppTop10Median: 'Top-10 Median',
    ppRecommended: 'Recommended',

    // Command Panel
    cmdMultiLine: 'Multi-line',
    cmdMonoLine: 'Mono-line',
    cmdClickToCopy: 'Click to copy',

    // Compare
    tabCompare: 'Compare',
    tabTimeline: 'Timeline',
    compareTitle: 'Compare runs',
    compareDesc: 'Select a run to compare with the current one',
    compareSearchPlaceholder: 'Search for a run...',
    compareMetrics: 'Metrics comparison',
    compareMetric: 'Metric',
    compareDelta: 'Delta (A-B)',
    compareParams: 'Parameters',
    compareChanged: 'changed',
    compareUnchanged: 'unchanged parameters',
    timelineTitle: 'Run History',
    timelineToday: 'Today',
    timelineYesterday: 'Yesterday',
    timelineEmpty: 'No runs yet',

    // Hyperopt Overview
    hoLossFunction: 'Loss Function',
    hoBestParameters: 'Best Parameters',
    hoBestEpochMetrics: 'Best Epoch — All Metrics',

    // Top 10 Table
    t10Title: 'Top 10 Epochs',
    t10Rank: '#',
    t10Loss: 'Loss',
    t10Profit: 'Profit %',
    t10Trades: 'Trades',
    t10Sharpe: 'Sharpe',
    t10DD: 'DD %',
    t10WinRate: 'Win %',
    t10Parameters: 'Parameters',
    t10ViewMetrics: 'View backtest metrics',
    t10EpochMetrics: 'Epoch Backtest Metrics',

    // WFA Overview
    wfaVerdict: 'Walk-Forward Verdict',
    wfaVerdictChecks: 'Verdict Checks',

    // WFA Charts
    wfaNoData: 'No WFA data available.',

    // WFA Cards
    wfaOosEquity: 'OOS Equity Curve',
    wfaTotalReturn: 'Total Return',
    wfaMaxDD: 'Max DD',
    wfaKRatio: 'K-Ratio',
    wfaTrades: 'Trades',
    wfaHoldout: 'Holdout Validation',
    wfaPerturbation: 'Parameter Perturbation',
    wfaPerturbProfitP50: 'Profit P50',
    wfaPerturbP5: 'P5 (worst)',
    wfaPerturbP95: 'P95 (best)',
    wfaMonteCarlo: 'Monte Carlo (OOS)',
    wfaCarverDiscount: 'Carver Discount',
    wfaDdPercentiles: 'Drawdown Percentiles',
    wfaAvgReturn: 'Avg Return',
    wfaSharpePaths: 'Sharpe of Paths',
    wfaCombinations: 'Combinations',
    wfaPaths: 'Paths',
    wfaCpcvTitle: 'CPCV (Combinatorial Purged Cross-Validation)',
    wfaParamStability: 'Parameter Stability',
    wfaParamName: 'Parameter',
    wfaParamMedian: 'Median',
    wfaParamStd: 'Std',
    wfaParamStatus: 'Status',
    wfaParamValues: 'Values',
    wfaRegimeTitle: 'Regime Analysis',
    wfaRegimeProfit: 'Profit',
    wfaRegimeTrades: 'Trades',
    wfaRegimeWinRate: 'Win Rate',
    wfaRegimeSharpe: 'Sharpe',
    wfaDegradationTitle: 'Degradation per Window',
    wfaDegWindow: 'Window',
    wfaDegTrainProfit: 'Train Profit',
    wfaDegTestProfit: 'Test Profit',
    wfaDegProfit: 'Deg. Profit',
    wfaDegSharpe: 'Deg. Sharpe',
    wfaDegCalmar: 'Deg. Calmar',

    // WFA additional keys
    wfaWindow: 'Window',
    wfaTrainProfit: 'Train Profit',
    wfaTestProfit: 'Test Profit',
    wfaStd: 'Std Dev',
    wfaStdRange: 'Range',
    wfaStatus: 'Status',
    wfaValues: 'Values',
    wfaStable: 'Stable',
    wfaMixed: 'Mixed',
    wfaUnstable: 'Unstable',
    wfaParamStabilityTitle: 'Parameter Stability Analysis',
    wfaPerturbTitle: 'Perturbation Analysis',
    wfaPerturbations: '{n} perturbations tested',
    wfaHoldoutTitle: 'Holdout Validation',
    wfaOosEquityTitle: 'Out-of-Sample Equity',
    wfaRegimeDependent: 'Strategy is regime-dependent',
    wfaRegimeRobust: 'Strategy is regime-robust',
    wfaWorstRegime: 'Worst regime: {regime}',
    wfaMcTitle: 'Monte Carlo Simulation',
    wfaMcDdPercentiles: 'Drawdown Percentiles',
    wfaMcReturnDdRatio: 'Return / Drawdown Ratio',

    // Run detail header
    rdhFavorite: 'Favorite',
    rdhNotes: 'Notes',
    rdhClickToEdit: 'Click to edit',
    rdhAddNotes: 'Add notes...',
    rdhSave: 'Save',
    rdhCancel: 'Cancel',

    // Parameter Recommendation Table
    prtTitle: 'Parameter Recommendations',
    prtParam: 'Parameter',
    prtType: 'Type',
    prtBest: 'Best',
    prtRecommended: 'Rec.',
    prtMedian: 'Median',
    prtSearchRange: 'Search Range',
    prtTop10Range: 'Top-10 Range',
    prtDistribution: 'Distribution',
    prtBpFullRange: 'Full range',
    prtBpMean: 'Mean',
    prtTendency: 'Tendency',
    prtSensitivity: 'Sensitivity',
    prtReasoning: 'Analysis',
    prtConverging: 'Converging',
    prtBoundary: 'Boundary cluster',
    prtSpread: 'Spread',
    prtStable: 'Stable',
    prtUnstable: 'Unstable',
    prtSensHigh: 'High',
    prtSensMedium: 'Medium',
    prtSensLow: 'Low',
    prtReasonConverging: 'Top-10 values converge to a narrow range — clear optimal zone',
    prtReasonBoundary: 'Values cluster at a range boundary — consider extending the search space',
    prtReasonSpread: 'Top-10 values are spread across the range — no clear optimum',
    prtReasonHighSens: 'Loss is highly sensitive to this parameter — tune carefully',
    prtReasonLowSens: 'Loss barely changes with this parameter — consider fixing it',
    prtReasonStable: 'Stable across top epochs — reliable value',
    prtReasonUnstable: 'Varies widely across top epochs — unreliable',
    prtSummaryAllClear:
      'All parameters converge — robust optimization. Recommended values are trustworthy.',
    prtSummaryMostSpread:
      'Most parameters are spread — the optimizer found no clear optimum. Consider narrowing the search space or adding more epochs.',
    prtSummaryMixed:
      '{converging}/{total} parameters converge, {spread} are spread — review spread parameters carefully.',
    prtHowToReadTitle: 'How to read this table',
    prtHowToRead1:
      '"Best" is the value from the best epoch. "Rec." is the median of the top-5 epochs — more robust than the single best.',
    prtHowToRead2:
      '"Top-10 Range" shows how much this parameter varies across top results. A narrow range means the optimizer agrees on a value.',
    prtHowToRead3:
      '"Tendency: Converging" means top-10 values cluster tightly (good). "Boundary cluster" means they hit a search space limit — try widening it.',
    prtHowToRead4:
      '"Sensitivity: High" means small changes in this parameter significantly affect the loss — it matters a lot. "Low" means it barely matters — you could fix it to any reasonable value.',

    // No analysis
    noAnalysisData: 'No analysis data available. The .fthypt file may not exist.',

    // Median label
    median: 'Median',
    min: 'Min',
    max: 'Max',
    stable: 'stable',
    unstable: 'unstable',
    marginal: 'marginal',
  },

  // Column Editor
  columnEditor: {
    title: 'Columns',
    reset: 'Reset to defaults',
  },

  // Trading mode filter
  tradingModeFilter: {
    allModes: 'All modes',
    liveOnly: 'Live only',
    dryOnly: 'Dry only',
  },

  // Widget Defaults
  widgetDefaults: {
    saveAsDefault: 'Save as default',
    saved: 'Defaults saved',
  },

  // Boot splash (shown briefly between page load and the first paint of the dashboard)
  boot: {
    connecting: 'Connecting to bots…',
    botsLoaded: '{loaded} / {total} bots loaded…',
    preparingDashboard: 'Preparing dashboard…',
  },
};
